unit BaseDashboardItem;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.ExtCtrls,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  SharedDataModule,
  Simple.Dashboard.Return.Types,
  Data.DB, Vcl.Forms, Sys.Return.Types,
  XData.Web.Client;


type
  TBaseDashboardItem = class(TPanel)
  private
    { Private declarations }
    FDashboardId: integer;
    FTitleLabel: TLabel;
    FTemplate: TDashboardItemTemplate;
    FDashboardParameters: string;
    FResponse: TDashboardResponse;
    FChartType: string;
    FChartTypeFixed: boolean;
    FSummaryIndex: integer;
    FSummaryFieldCount: integer;

    FChartPanel: TPanel;
    FChartCanvasId: string;
    FChartData: string;
    FSummaryData: string;
    FSummaryGrid: TTableControl;
    FConfiguration: TDashboardItemConfig;
    FSummaryPresent: boolean;
    FSummaryGridPresent: boolean;
    FSummaryType: string;
    FFullSummary: boolean;


    FOwner: TComponent;
    FTitle: string;
    FYValueNames: string;
    FXLabelNames: string;
    //FLegendText: string;
    FDashboardIndex: integer;
    FDrillDownPresent: boolean;
    FDrillDownSQL: string;
    FComboBox: TComboBox;
    FCardHeaderPanel: TPanel;
    FCardBodyPanel: TPanel;
    FCardFooterPanel: TPanel;
    FLoadingPanel: TPanel;
    FLoadingLabel: TLabel;
    ChartTimer: TTimer;
    FYear: integer;
    FIndividualFetchReason: string;
    FChartHoverTimer: TTimer;

    [async]
    procedure ComboBoxChange(Sender: TObject); async;
    procedure ChartTimerTimer(Sender: TObject);
    [async]
    procedure ChartHoverTimerTick(Sender: TObject); async;
    function GetSummaryFieldCount: integer;
    procedure TestClick(Sender: TObject);
    procedure CreateChartCanvas(const APanelId, ACanvasId: string);
    procedure EnsureChartCanvas;
    procedure RenderChartJs(const ADataJSON, AYValueNames, AXLabelNames,
      AChartType: string; ALegendData: TArray<string>; AEnableHoverSelection: Boolean);
    function UsesChartHoverSummary: Boolean;
    procedure UpdateChartSelectionHighlight(AIndex: Integer);
    procedure EnsureChartHoverHandlers;
    procedure EnsureChartHoverTimer;
    procedure StoreChartHoverMetadata;
    function GetChartRowFieldValue(ARowIndex: Integer; const AFieldName: string): string;
  protected
    procedure SetTitle(ATitle: string);
    procedure AddChartAndData(ADataJSON: string);
    procedure CreateChart;
    procedure CreateTitleLabel;
    procedure EnsureCardHeader;
    procedure EnsureCardBody;
    procedure EnsureCardFooter;
    procedure EnsureLoadingOverlay;
    procedure SyncCardFooterVisibility;
    function UsesCardFooter: Boolean;
    function GetSummaryTableParentPanel: TPanel;
    procedure EnsureCardChromeClasses;
    procedure ApplyCardChrome(const ATitle: string);
    procedure NormalizeWidgetLayout;
    procedure UpdateChartPanelVisibility;
    function GetEffectiveChartHeight: integer;

    procedure PopulateSummaryTableRowData(ARowIndex: integer; ARowData: JS.TJSObject);

    function RequiresDrillDownSQL: Boolean; virtual;
    function ShouldRunSummarySQLOnComboChange: Boolean; virtual;
    function ShowSummaryCombo: Boolean; virtual;
    function GetSummaryIterationCount: Integer; virtual;
    function ResolveSummaryColumnName(AFieldIndex, AIterationIndex: Integer): string; virtual;
    function FormatSummaryCellValue(const AFieldType, AFieldName, AValue: string): string;
    function GetCurrencySymbol: string;
    function IsCurrencyFieldType(const AFieldType: string): Boolean;
    function LooksLikeCurrencyFieldName(const AFieldName: string): Boolean;
    function ShouldFormatAsCurrency(const AFieldType, AFieldName: string): Boolean;
    function IsCurrencyFieldName(const AFieldName: string): Boolean;
    function NormalizeCurrencyValue(const AValue: string): string;
    function FormatCurrencyValue(const AValue: string): string;
    function BuildCurrencyFieldNamesJson: string;

    procedure CreateSummaryFieldsTableRowIndex(ASummaryData: string; ARowIndex: integer); virtual;
    procedure SetDashboardId(ADashboardItemId: integer);

//    procedure CreateSummaryTable(ASummaryData: string; AFieldNames: TArray<String>);overload;
    procedure CreateSummaryTable(ARowCount: integer; AColumnCount: integer); virtual;//overload;

    procedure PopulateSummaryTableData(ASummaryData: string; AColumnCount: integer; ARowCount: integer); virtual;
    procedure PopulateSummaryTableFromJson(const ADataJSON: string; AMaxRows: Integer = 0);
    [async]
    procedure RunSummary(AIndex: integer); async;
    [async]
    procedure NewSummarySelected; async; virtual;

    [async]
    procedure RunSummarySQL(ASQL: string); async; virtual;
    [async]
    procedure ExecuteDrillDownForChartRow(AIndex: Integer); async;
    function GetChartRowDrillDownParam(AIndex: Integer): string;

    procedure CreateComboBox;
    procedure PopulateComboBox; virtual;
    procedure RemoveSummaryCombo;
    procedure HideSummaryCombo;
    procedure UpdateSummaryComboVisibility;
    function GetEffectiveDrillDownFieldName: string;
    function IsDrillDownComboEnabled: Boolean;
    function ResolveSqlParameters(const ASQL: string): string;
    function FormatDrillDownParameterValue(const AFieldName, AValue: string): string;
    function ReplaceDrillDownPlaceholder(const ASQL, AFieldName, AValue: string): string;
    procedure EnsureDrillDownSQLLoaded(const AResponse: TDashboardResponse);
    procedure EnsureSummaryGridVisible;
    procedure HideSummaryGridIfEmpty;
    function IsChartOnlyWidget: Boolean;
    function IsDayLikeForLikeWidget: Boolean;
    function IsTradingPatternWidget: Boolean;
    procedure ApplyChartPanelHeight;
    function RequiresSqlDrillDownSummary: Boolean;
    function RequiresConfigDrillDownSummary: Boolean;
    function GetComboFieldName: string;
    procedure EnsureSummaryFieldsReady(const ADataJSON: string);
    function UsesComboRowSummary: Boolean;
    function ShouldShowFullSummaryTable: Boolean;
    function UsesChartSummaryFixedHeight: Boolean;
    function GetChartSummaryVisibleRowCount: Integer;
    function GetSummaryTableLayoutDataRowCount: Integer;
    function ResolveChartSummaryGridRowCount(ADataRowCount: Integer): Integer;
    procedure EnsureSummaryGridDataRows(ADataRowCount, AColumnCount: Integer);
    function GetChartSummaryViewportHeight: Integer;
    function GetChartSummaryFooterHeight: Integer;
    procedure SyncSummaryGridContentHeight;
    function GetSummaryFieldValue(ARowData: JS.TJSObject; AFieldIndex: Integer): string;
    function GetSummaryFieldValueAtIteration(ARowData: JS.TJSObject; AFieldIndex,
      AIterationIndex: Integer): string;
    function ExtractChartRowJson(const ADataJSON: string; ARowIndex: Integer): string;
    procedure PopulateComboRowTable(ARowIndex: Integer); virtual;
    [async]
    procedure DisplayComboRowSummary; async;
    [async]
    procedure DisplayDrillDownWithCombo; async;

    procedure ProcessResponse(AResponse: TDashboardResponse); virtual;
    procedure CreateComponents; virtual;
    [async]
    procedure DisplayData; async; virtual;

    function GetChartHeight: integer; virtual; abstract;
    function GetSummaryRowCount: integer; virtual; abstract;
    function GetSummaryColCount: integer; virtual; abstract;

    procedure SetTemplate(ATemplate: TDashboardItemTemplate);
    procedure LoadConfigurationFromJSON(const AConfigJSON: string);
    procedure NormalizeConfigurationArrayFields(AConfigObj: JS.TJSObject);
    procedure SetConfiguration;
//    procedure SetParameters;
    procedure ResolveLegend;

  public
    { Public declarations }
    procedure ShowChartNoData;
    constructor Create(AOwner: TComponent);override;
    [async]
    function LoadData: TDashboardResponse; async; virtual;
    [async]
    procedure ApplyData(AResponse: TDashboardResponse; const ADeferPresentation: Boolean = False); async; virtual;
    procedure StageBulkData(AResponse: TDashboardResponse);
    [async]
    procedure PresentBulkData; async;
    [async]
    procedure LoadAndApply; async; virtual;

    [async]
    function Run: boolean; async; virtual;

    procedure Refresh; virtual;

    procedure PrepareShell(const ATitle: string);
    procedure ShowDataSkeleton;
    procedure HideDataSkeleton;
    procedure EnsureChartReadyForRender;
    procedure CancelWidgetSkeletonTimer;
    procedure RemoveAllLoadingOverlays;
    procedure StripWidgetLoadingChrome;
    procedure RestoreChartPanelVisibility;
    procedure FinalizeChartLayout;
    procedure ShowErrorState;
    procedure ApplyLayoutSettings;
    procedure ApplyWidgetTableHeaderStyles;
    procedure ConfigureSummaryTableInteraction;
    procedure ApplySummaryTableLayout;
    procedure LockChartSummaryFooterLayout;
    function GetSummaryTableFixedHeight: Integer;
    function GetSummaryTableRowHeight: Integer;

    function HasChartData(const ADataJSON: string): Boolean;
    function HasRenderedChart: Boolean;
    function HasDisplayedContent: Boolean;
    function CanEndLoadingOverlay: Boolean;
    function GetEffectiveChartJson: string;
    function RequiresChart: Boolean;

    [async]
    procedure HandleChartRowHover(AIndex: Integer); async;
    [async]
    procedure LoadChartRowDrillDownSummary(AIndex: Integer); async;

    property IndividualFetchReason: string read FIndividualFetchReason write FIndividualFetchReason;
    property ChartPanel: TPanel read FChartPanel;
    property Title: string read FTitle write SetTitle;
    property Template: TDashboardItemTemplate read FTemplate write SetTemplate;
    property SummaryGridPresent: boolean read FSummaryGridPresent write FSummaryGridPresent;
    property DashboardId: integer read FDashboardId write SetDashboardId;
    property DashboardParameters: string read FDashboardParameters write FDashboardParameters;
    property SummaryComboBox: TComboBox read FComboBox write FComboBox;
    property Configuration: TDashboardItemConfig read FConfiguration;
    property DrillDownSQL: string read FDrillDownSQL;
    property ChartData: string read FChartData;
    property ChartTypeName: string read FChartType;
    property SummaryData: string read FSummaryData;
    property SummaryGrid: TTableControl read FSummaryGrid write FSummaryGrid;
    property SummaryFieldCount: integer read FSummaryFieldCount write FSummaryFieldCount;
    property Year: integer read FYear write FYear;
    //property Parameters:
  end;


implementation

{ TMappingsForm }

uses
  System.UITypes;


constructor TBaseDashboardItem.Create(AOwner: TComponent);
begin
  inherited;

  FOwner := AOwner;
  FSummaryIndex := 0;
  Color := clWhite;
  BorderStyle := bsNone;
  WidthPercent := 100;
  WidthStyle := ssAuto;
  HeightStyle := ssAuto;
  ElementPosition := epRelative;
  Left := 0;
  Top := 0;
end;

procedure TBaseDashboardItem.CreateChart;
begin
  if not assigned(FChartPanel) then
  begin
    EnsureCardBody;
    FChartCanvasId := 'csy_chart_' + IntToStr(FDashboardId) + '_' + IntToStr(Random(1000000));

    FChartPanel := TPanel.Create(Self);
    FChartPanel.ElementID := FChartCanvasId + '_panel';
    FChartPanel.Top := 0;
    FChartPanel.Left := 0;
    FChartPanel.Parent := FCardBodyPanel;
    FChartPanel.Align := alClient;
    FChartPanel.HeightStyle := ssPercent;
    FChartPanel.HeightPercent := 100;
    FChartPanel.WidthPercent := 100;
    FChartPanel.WidthStyle := ssPercent;
    FChartPanel.BorderStyle := bsNone;
    FChartPanel.ElementPosition := epRelative;
    FChartPanel.ElementClassName := 'card-body-chart position-relative';

    CreateChartCanvas(FChartPanel.ElementID, FChartCanvasId);
  end;
end;

procedure TBaseDashboardItem.CreateChartCanvas(const APanelId, ACanvasId: string);
begin
  asm
    var panel = document.getElementById(APanelId);
    if (!panel) {
      return;
    }

    panel.innerHTML = "";
    panel.style.position = "relative";
    panel.style.minHeight = "160px";
    panel.textContent = "";
  end;
end;

function TBaseDashboardItem.GetEffectiveChartHeight: integer;
const
  CHART_AREA_HEIGHT = 340;
begin
  if GetChartHeight <= 0 then
    Result := 0
  else
    Result := CHART_AREA_HEIGHT;
end;

procedure TBaseDashboardItem.ApplyChartPanelHeight;
begin
  if Trim(FChartCanvasId) = '' then
    Exit;

  asm
    var root = document.getElementById(this.ElementID);
    var panel = document.getElementById(this.FChartCanvasId + '_panel');
    var canvas = document.getElementById(this.FChartCanvasId);
    var chartHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--csy-chart-height').trim() || '380px';

    if (panel) {
      panel.style.display = 'flex';
      panel.style.flexDirection = 'column';
      panel.style.position = 'relative';
      panel.style.width = '100%';
      panel.style.maxWidth = '100%';
      panel.style.height = chartHeight;
      panel.style.minHeight = chartHeight;
      panel.style.maxHeight = chartHeight;
      panel.style.flex = '0 0 ' + chartHeight;
      panel.style.overflow = 'hidden';
      panel.style.boxSizing = 'border-box';
    }
    if (canvas) {
      canvas.style.position = 'absolute';
      canvas.style.inset = '0';
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.maxWidth = '100%';
      canvas.style.maxHeight = '100%';
    }
    if (root) {
      var body = document.getElementById('csy_body_' + this.FDashboardId);
      if (body) {
        body.style.height = chartHeight;
        body.style.minHeight = chartHeight;
        body.style.maxHeight = chartHeight;
        body.style.flex = '0 0 ' + chartHeight;
        body.style.overflow = 'hidden';
      }
    }
    if (canvas && canvas.__csyChart && typeof canvas.__csyChart.resize === 'function') {
      canvas.__csyChart.resize();
    }
  end;
end;

procedure TBaseDashboardItem.ApplyWidgetTableHeaderStyles;
begin
  asm
    var tableRoot = document.getElementById('csy_summary_' + this.FDashboardId);
    if (!tableRoot) {
      return;
    }
    var table = tableRoot.tagName === 'TABLE' ? tableRoot : tableRoot.querySelector('table');
    if (!table) {
      return;
    }
    var rows = table.querySelectorAll('tr');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.remove('csy-table-header', 'csy-table-data', 'csy-empty-row');
    }
    if (rows.length > 0) {
      rows[0].classList.add('csy-table-header');
      for (var j = 1; j < rows.length; j++) {
        rows[j].classList.add('csy-table-data');
        var cells = rows[j].querySelectorAll('td, th');
        var empty = true;
        for (var c = 0; c < cells.length; c++) {
          if (String(cells[c].textContent || '').trim() !== '') {
            empty = false;
            break;
          }
        }
        if (empty) {
          rows[j].classList.add('csy-empty-row');
        }
      }
    }

    // Host is a DIV from TWebTableControl — keep it block. The inner TABLE must
    // stay display:table or header/body column widths diverge.
    if (tableRoot !== table) {
      tableRoot.style.width = '100%';
      tableRoot.style.maxWidth = '100%';
      tableRoot.style.display = 'block';
      tableRoot.style.boxSizing = 'border-box';
    }
    table.style.display = 'table';
    table.style.width = '100%';
    table.style.minWidth = '100%';
    table.style.maxWidth = '100%';
    table.style.tableLayout = 'fixed';
    table.style.borderCollapse = 'collapse';
    table.style.boxSizing = 'border-box';

    var colCount = 0;
    if (rows.length > 0 && rows[0].cells) {
      colCount = rows[0].cells.length;
    }
    if (colCount > 0) {
      var colPct = (100 / colCount) + '%';
      var oldGroup = table.querySelector('colgroup[data-csy-cols]');
      if (oldGroup) {
        oldGroup.remove();
      }
      var colgroup = document.createElement('colgroup');
      colgroup.setAttribute('data-csy-cols', '1');
      for (var c = 0; c < colCount; c++) {
        var col = document.createElement('col');
        col.style.width = colPct;
        colgroup.appendChild(col);
      }
      table.insertBefore(colgroup, table.firstChild);

      for (var ri = 0; ri < rows.length; ri++) {
        for (var ci = 0; ci < rows[ri].cells.length; ci++) {
          var cell = rows[ri].cells[ci];
          cell.style.width = colPct;
          cell.style.minWidth = '0';
          cell.style.maxWidth = 'none';
          cell.style.textAlign = 'center';
          cell.style.boxSizing = 'border-box';
          cell.removeAttribute('align');
          var inner = cell.firstElementChild;
          if (inner && inner.tagName === 'DIV') {
            inner.style.width = '100%';
            inner.style.maxWidth = '100%';
            inner.style.boxSizing = 'border-box';
            inner.style.textAlign = 'center';
          }
        }
      }
    }
  end;
end;

procedure TBaseDashboardItem.ConfigureSummaryTableInteraction;
begin
  asm
    var summary = document.getElementById('csy_summary_' + this.FDashboardId);
    if (!summary) {
      return;
    }
    summary.setAttribute('data-csy-summary', '1');
    var table = summary.tagName === 'TABLE' ? summary : summary.querySelector('table');
    if (!table) {
      return;
    }
    table.setAttribute('data-csy-summary', '1');
    if (table.dataset.csyInteractionBound) {
      return;
    }
    table.dataset.csyInteractionBound = '1';
    table.style.userSelect = 'none';
    var guard = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    };
    table.addEventListener('mousedown', guard, true);
    table.addEventListener('click', guard, true);
  end;
end;

procedure TBaseDashboardItem.ApplyLayoutSettings;
var
  lSummaryParent: TPanel;
begin
  EnsureCardHeader;
  EnsureCardBody;
  lSummaryParent := GetSummaryTableParentPanel;
  if Assigned(FTitleLabel) and Assigned(FCardHeaderPanel) and (FTitleLabel.Parent <> FCardHeaderPanel) then
    FTitleLabel.Parent := FCardHeaderPanel;
  if Assigned(FComboBox) and Assigned(FCardHeaderPanel) and (FComboBox.Parent <> FCardHeaderPanel) then
    FComboBox.Parent := FCardHeaderPanel;
  if Assigned(FChartPanel) and Assigned(FCardBodyPanel) and (FChartPanel.Parent <> FCardBodyPanel) then
    FChartPanel.Parent := FCardBodyPanel;
  if Assigned(FSummaryGrid) and (FSummaryGrid.Parent <> lSummaryParent) then
    FSummaryGrid.Parent := lSummaryParent;
  EnsureCardChromeClasses;
  NormalizeWidgetLayout;
  ApplyWidgetTableHeaderStyles;
  if Assigned(FSummaryGrid) then
    ApplySummaryTableLayout;
  LockChartSummaryFooterLayout;
end;

procedure TBaseDashboardItem.NormalizeWidgetLayout;
begin
  ElementPosition := epRelative;
  Left := 0;
  Top := 0;
  WidthPercent := 100;
  WidthStyle := ssAuto;
  HeightStyle := ssAuto;

  if Assigned(FCardHeaderPanel) then
  begin
    FCardHeaderPanel.ElementPosition := epRelative;
    FCardHeaderPanel.Left := 0;
    FCardHeaderPanel.Top := 0;
    FCardHeaderPanel.WidthPercent := 100;
    FCardHeaderPanel.WidthStyle := ssAuto;
    FCardHeaderPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FCardBodyPanel) then
  begin
    FCardBodyPanel.ElementPosition := epRelative;
    FCardBodyPanel.Left := 0;
    FCardBodyPanel.Top := 0;
    FCardBodyPanel.WidthPercent := 100;
    FCardBodyPanel.WidthStyle := ssAuto;
    FCardBodyPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FCardFooterPanel) then
  begin
    FCardFooterPanel.ElementPosition := epRelative;
    FCardFooterPanel.Left := 0;
    FCardFooterPanel.Top := 0;
    FCardFooterPanel.WidthPercent := 100;
    FCardFooterPanel.WidthStyle := ssAuto;
    FCardFooterPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FTitleLabel) then
  begin
    FTitleLabel.ElementPosition := epRelative;
    FTitleLabel.Left := 0;
    FTitleLabel.Top := 0;
    FTitleLabel.WidthPercent := 100;
    FTitleLabel.WidthStyle := ssAuto;
    FTitleLabel.HeightStyle := ssAuto;
  end;
  if Assigned(FComboBox) then
  begin
    FComboBox.ElementPosition := epRelative;
    FComboBox.Left := 0;
    FComboBox.Top := 0;
    FComboBox.WidthStyle := ssAuto;
    if UsesChartHoverSummary or not ShowSummaryCombo then
      RemoveSummaryCombo;
  end;
  if Assigned(FChartPanel) then
  begin
    FChartPanel.ElementPosition := epRelative;
    FChartPanel.Left := 0;
    FChartPanel.Top := 0;
    FChartPanel.WidthPercent := 100;
    FChartPanel.WidthStyle := ssAuto;
    FChartPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FSummaryGrid) then
  begin
    FSummaryGrid.ElementPosition := epRelative;
    FSummaryGrid.Left := 0;
    FSummaryGrid.Top := 0;
    FSummaryGrid.WidthPercent := 100;
    FSummaryGrid.WidthStyle := ssAuto;
    if UsesChartSummaryFixedHeight and UsesCardFooter then
      FSummaryGrid.HeightStyle := ssAuto
    else
      FSummaryGrid.HeightStyle := ssAuto;
  end;

  asm
    var root = document.getElementById(this.ElementID);
    if (root) {
      root.style.height = 'auto';
      root.style.minHeight = '0';
      root.style.overflow = 'visible';
    }
    var header = document.getElementById('csy_header_' + this.FDashboardId);
    if (header && root && header.parentElement !== root) {
      root.insertBefore(header, root.firstChild);
    }
    if (header) {
      header.classList.add('csy-card-header');
      header.style.setProperty('position', 'relative', 'important');
      header.style.setProperty('left', 'auto', 'important');
      header.style.setProperty('top', 'auto', 'important');
      header.style.setProperty('width', '100%', 'important');
      header.style.setProperty('min-width', '100%', 'important');
      header.style.setProperty('max-width', '100%', 'important');
      header.style.setProperty('align-self', 'stretch', 'important');
      header.style.setProperty('display', 'flex', 'important');
      header.style.setProperty('box-sizing', 'border-box', 'important');
      header.style.height = 'auto';
      header.style.minHeight = '2.75rem';
      header.style.padding = '0.875rem 1.5rem 0.875rem 1.75rem';
    }
    var title = document.getElementById('csy_title_' + this.FDashboardId);
    if (title) {
      title.style.width = 'auto';
      title.style.maxWidth = '100%';
      title.style.flex = '1 1 auto';
      title.style.overflow = 'visible';
      title.style.whiteSpace = 'normal';
      title.style.display = 'block';
    }
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    if (body) {
      body.style.position = 'relative';
      body.style.left = 'auto';
      body.style.top = 'auto';
      body.style.right = 'auto';
      body.style.width = '100%';
      body.style.maxWidth = '100%';
    }
    var footer = document.getElementById('csy_footer_' + this.FDashboardId);
    if (footer) {
      footer.style.position = 'relative';
      footer.style.left = 'auto';
      footer.style.top = 'auto';
      footer.style.right = 'auto';
      footer.style.width = '100%';
      footer.style.maxWidth = '100%';
    }
    var summary = document.getElementById('csy_summary_' + this.FDashboardId);
    if (summary) {
      summary.style.position = 'relative';
      summary.style.left = '0';
      summary.style.top = '0';
      summary.style.width = '100%';
      summary.style.maxWidth = '100%';
    }
  end;

  if Assigned(FChartPanel) then
    ApplyChartPanelHeight;
  LockChartSummaryFooterLayout;
end;

procedure TBaseDashboardItem.EnsureCardHeader;
begin
  if Assigned(FCardHeaderPanel) then
    Exit;

  FCardHeaderPanel := TPanel.Create(Self);
  FCardHeaderPanel.Parent := Self;
  FCardHeaderPanel.Align := alTop;
  FCardHeaderPanel.ElementPosition := epRelative;
  FCardHeaderPanel.ElementID := 'csy_header_' + IntToStr(FDashboardId);
  FCardHeaderPanel.ElementClassName := 'csy-card-header';
  FCardHeaderPanel.BorderStyle := bsNone;
  FCardHeaderPanel.WidthPercent := 100;
  FCardHeaderPanel.WidthStyle := ssAuto;
  FCardHeaderPanel.HeightStyle := ssAuto;
end;

procedure TBaseDashboardItem.EnsureCardBody;
begin
  if Assigned(FCardBodyPanel) then
    Exit;

  EnsureCardHeader;
  FCardBodyPanel := TPanel.Create(Self);
  FCardBodyPanel.Parent := Self;
  FCardBodyPanel.Align := alTop;
  FCardBodyPanel.ElementPosition := epRelative;
  FCardBodyPanel.ElementID := 'csy_body_' + IntToStr(FDashboardId);
  FCardBodyPanel.ElementClassName := 'csy-card-body card-body';
  FCardBodyPanel.BorderStyle := bsNone;
  FCardBodyPanel.WidthPercent := 100;
  FCardBodyPanel.WidthStyle := ssAuto;
  FCardBodyPanel.HeightStyle := ssAuto;

  EnsureLoadingOverlay;
end;

procedure TBaseDashboardItem.EnsureLoadingOverlay;
begin
  EnsureCardBody;
  if Assigned(FLoadingPanel) then
    Exit;

  FLoadingPanel := TPanel.Create(FCardBodyPanel);
  FLoadingPanel.Parent := FCardBodyPanel;
  FLoadingPanel.ElementID := 'csy_loading_' + IntToStr(FDashboardId);
  FLoadingPanel.ElementClassName := 'csy-widget-skeleton';
  FLoadingPanel.ElementPosition := epRelative;
  FLoadingPanel.BorderStyle := bsNone;
  FLoadingPanel.WidthPercent := 100;
  FLoadingPanel.WidthStyle := ssPercent;
  FLoadingPanel.HeightPercent := 100;
  FLoadingPanel.HeightStyle := ssPercent;
  FLoadingPanel.Visible := True;

  FLoadingLabel := TLabel.Create(FLoadingPanel);
  FLoadingLabel.Parent := FLoadingPanel;
  FLoadingLabel.ElementID := 'csy_loading_text_' + IntToStr(FDashboardId);
  FLoadingLabel.ElementClassName := 'csy-widget-loading-text';
  FLoadingLabel.Caption := 'Loading metrics...';
  FLoadingLabel.ElementPosition := epRelative;
  FLoadingLabel.WidthPercent := 100;
  FLoadingLabel.WidthStyle := ssPercent;
  FLoadingLabel.HeightStyle := ssAuto;
  FLoadingLabel.Visible := True;

  asm
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    var loading = document.getElementById('csy_loading_' + this.FDashboardId);
    if (body && loading) {
      body.style.position = 'relative';
      body.style.overflow = 'hidden';
      loading.style.position = 'absolute';
      loading.style.inset = '0';
      loading.style.zIndex = '10';
      loading.style.display = 'flex';
      loading.style.flexDirection = 'column';
      loading.style.alignItems = 'center';
      loading.style.justifyContent = 'center';
    }
  end;
end;

procedure TBaseDashboardItem.EnsureCardFooter;
begin
  if Assigned(FCardFooterPanel) then
    Exit;

  FCardFooterPanel := TPanel.Create(Self);
  FCardFooterPanel.Parent := Self;
  FCardFooterPanel.Align := alTop;
  FCardFooterPanel.ElementPosition := epRelative;
  FCardFooterPanel.ElementID := 'csy_footer_' + IntToStr(FDashboardId);
  FCardFooterPanel.ElementClassName := 'csy-card-footer card-footer';
  FCardFooterPanel.BorderStyle := bsNone;
  FCardFooterPanel.WidthPercent := 100;
  FCardFooterPanel.WidthStyle := ssAuto;
  FCardFooterPanel.HeightStyle := ssAuto;
end;

function TBaseDashboardItem.UsesCardFooter: Boolean;
begin
  if GetChartHeight <= 0 then
    Exit(False);
  if IsChartOnlyWidget then
    Exit(False);
  Result := True;
end;

function TBaseDashboardItem.GetSummaryTableParentPanel: TPanel;
begin
  EnsureCardBody;
  if UsesCardFooter then
  begin
    EnsureCardFooter;
    FCardFooterPanel.Visible := True;
    Result := FCardFooterPanel;
  end
  else
    Result := FCardBodyPanel;
  SyncCardFooterVisibility;
end;

procedure TBaseDashboardItem.SyncCardFooterVisibility;
begin
  if Assigned(FCardFooterPanel) then
    FCardFooterPanel.Visible := UsesCardFooter;

  if UsesCardFooter then
  begin
    asm
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      if (footer) {
        footer.style.display = 'block';
      }
    end;
    LockChartSummaryFooterLayout;
  end
  else
  begin
    asm
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      if (footer) {
        footer.style.display = 'none';
      }
    end;
  end;
end;

function TBaseDashboardItem.UsesChartSummaryFixedHeight: Boolean;
begin
  Result := (GetChartHeight > 0) and not IsChartOnlyWidget;
end;

function TBaseDashboardItem.GetChartSummaryVisibleRowCount: Integer;
begin
  // LFL dual-period summaries need 2 visible rows; trading patterns show one
  // selected chart point at a time.
  Result := GetSummaryIterationCount;
  if Result < 1 then
    Result := 1;
end;

function TBaseDashboardItem.GetSummaryTableLayoutDataRowCount: Integer;
begin
  if UsesChartSummaryFixedHeight and UsesCardFooter then
    Result := GetChartSummaryVisibleRowCount
  else
    Result := GetSummaryRowCount;
end;

function TBaseDashboardItem.GetChartSummaryViewportHeight: Integer;
begin
  Result := (GetChartSummaryVisibleRowCount + 1) * GetSummaryTableRowHeight;
end;

function TBaseDashboardItem.GetChartSummaryFooterHeight: Integer;
begin
  Result := GetChartSummaryViewportHeight;
end;

procedure TBaseDashboardItem.LockChartSummaryFooterLayout;
var
  lFooterHeight: Integer;
begin
  if not UsesChartSummaryFixedHeight then
    Exit;
  if not UsesCardFooter then
    Exit;

  lFooterHeight := GetChartSummaryFooterHeight;
  if Assigned(FCardBodyPanel) then
  begin
    FCardBodyPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FCardFooterPanel) then
  begin
    FCardFooterPanel.HeightStyle := ssAuto;
  end;
  if Assigned(FSummaryGrid) then
  begin
    FSummaryGrid.HeightStyle := ssAuto;
  end;

  asm
    var root = document.getElementById(this.ElementID);
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    var footer = document.getElementById('csy_footer_' + this.FDashboardId);
    var summary = document.getElementById('csy_summary_' + this.FDashboardId);
    var footerHeight = lFooterHeight;
    var minBodyHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--csy-chart-height').trim() || '340px';
    if (root) {
      root.classList.add('csy-chart-summary-fixed', 'csy-uses-footer');
      root.style.height = 'auto';
      root.style.minHeight = '0';
      root.style.maxHeight = 'none';
    }
    if (body) {
      body.style.position = 'relative';
      body.style.left = 'auto';
      body.style.top = 'auto';
      body.style.right = 'auto';
      body.style.bottom = 'auto';
      body.style.height = minBodyHeight;
      body.style.minHeight = minBodyHeight;
      body.style.maxHeight = minBodyHeight;
      body.style.flex = '0 0 ' + minBodyHeight;
      body.style.overflow = 'hidden';
      body.style.paddingBottom = '0';
      body.style.zIndex = '0';
    }
    if (footer) {
      if (body && footer.parentElement === body.parentElement && body.nextSibling !== footer) {
        body.parentElement.insertBefore(footer, body.nextSibling);
      }
      footer.style.display = 'block';
      footer.style.position = 'relative';
      footer.style.left = 'auto';
      footer.style.top = 'auto';
      footer.style.right = 'auto';
      footer.style.bottom = 'auto';
      footer.style.height = 'auto';
      footer.style.minHeight = '0';
      footer.style.maxHeight = footerHeight + 'px';
      footer.style.flex = '0 0 auto';
      footer.style.flexShrink = '0';
      footer.style.padding = '0';
      footer.style.overflowX = 'hidden';
      footer.style.overflowY = 'auto';
      footer.style.boxSizing = 'border-box';
      footer.style.zIndex = '0';
      footer.style.background = '#fff';
    }
    if (summary && footer) {
      if (!footer.contains(summary)) {
        footer.appendChild(summary);
      }
      summary.style.position = 'relative';
      summary.style.left = '0';
      summary.style.top = '0';
      summary.style.width = '100%';
      summary.style.maxWidth = '100%';
      summary.style.height = 'auto';
      summary.style.minHeight = '0';
      summary.style.maxHeight = 'none';
      summary.style.overflow = 'visible';
      summary.style.display = 'block';
      summary.style.margin = '0';
      summary.style.padding = '0';
    }
    if (summary) {
      var table = summary.tagName === 'TABLE' ? summary : summary.querySelector('table');
      if (table) {
        table.style.width = '100%';
        table.style.minWidth = '100%';
        table.style.maxWidth = '100%';
        table.style.tableLayout = 'fixed';
        table.style.height = 'auto';
        table.style.minHeight = '0';
        table.style.maxHeight = 'none';
        table.style.marginBottom = '0';
      }
    }
  end;
end;

procedure TBaseDashboardItem.SyncSummaryGridContentHeight;
begin
  if not Assigned(FSummaryGrid) then
    Exit;
  if FSummaryGrid.RowCount <= 0 then
    Exit;
  if UsesChartSummaryFixedHeight and UsesCardFooter then
  begin
    FSummaryGrid.HeightStyle := ssAuto;
    asm
      var tableHost = document.getElementById(this.FSummaryGrid.ElementID);
      if (tableHost) {
        tableHost.style.height = 'auto';
        tableHost.style.minHeight = '0';
        tableHost.style.maxHeight = 'none';
      }
    end;
    Exit;
  end;

  FSummaryGrid.Height := FSummaryGrid.RowCount * GetSummaryTableRowHeight;
  FSummaryGrid.HeightStyle := ssAbsolute;
end;

function TBaseDashboardItem.ResolveChartSummaryGridRowCount(ADataRowCount: Integer): Integer;
begin
  if ADataRowCount < 0 then
    ADataRowCount := 0;
  Result := ADataRowCount + 1;
end;

procedure TBaseDashboardItem.EnsureSummaryGridDataRows(ADataRowCount, AColumnCount: Integer);
begin
  if AColumnCount <= 0 then
    AColumnCount := Length(FConfiguration.SummaryFields);
  if AColumnCount <= 0 then
    Exit;
  if ADataRowCount < 1 then
    ADataRowCount := 1;

  if not Assigned(FSummaryGrid) then
    CreateSummaryTable(ADataRowCount, AColumnCount)
  else
  begin
    FSummaryGrid.ColCount := AColumnCount;
    FSummaryGrid.RowCount := ResolveChartSummaryGridRowCount(ADataRowCount);
  end;
end;

function TBaseDashboardItem.GetSummaryTableRowHeight: Integer;
begin
  Result := 36;
end;

function TBaseDashboardItem.GetSummaryTableFixedHeight: Integer;
begin
  Result := (GetSummaryTableLayoutDataRowCount + 1) * GetSummaryTableRowHeight;
end;

procedure TBaseDashboardItem.ApplySummaryTableLayout;
var
  lTableHeight: Integer;
begin
  if not Assigned(FSummaryGrid) then
    Exit;

  if UsesChartSummaryFixedHeight and UsesCardFooter then
  begin
    FSummaryGrid.HeightStyle := ssAuto;
    FSummaryGrid.ElementPosition := epRelative;

    asm
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      var tableHost = document.getElementById(this.FSummaryGrid.ElementID);

      if (footer && tableHost) {
        var scrollWrap = footer.querySelector('.csy-summary-scroll-wrap');
        if (scrollWrap && scrollWrap.contains(tableHost)) {
          footer.insertBefore(tableHost, scrollWrap);
        }
        if (scrollWrap) {
          scrollWrap.remove();
        }
        if (!footer.contains(tableHost)) {
          footer.appendChild(tableHost);
        }
      }

      if (tableHost) {
        tableHost.style.position = 'relative';
        tableHost.style.left = '0';
        tableHost.style.top = '0';
        tableHost.style.width = '100%';
        tableHost.style.maxWidth = '100%';
        tableHost.style.height = '';
        tableHost.style.minHeight = '';
        tableHost.style.maxHeight = '';
        tableHost.style.overflow = 'visible';
        tableHost.style.display = 'block';
        tableHost.style.boxSizing = 'border-box';
        tableHost.style.margin = '0';
        tableHost.style.padding = '0';
      }

      var table = tableHost ? tableHost.querySelector('table') : null;
      if (table) {
        table.style.width = '100%';
        table.style.minWidth = '100%';
        table.style.maxWidth = '100%';
        table.style.tableLayout = 'fixed';
        table.style.margin = '0';
      }
    end;

    LockChartSummaryFooterLayout;
    Exit;
  end;

  lTableHeight := (GetSummaryRowCount + 1) * GetSummaryTableRowHeight;
  FSummaryGrid.RowCount := GetSummaryRowCount + 1;
  FSummaryGrid.Height := lTableHeight;
  FSummaryGrid.HeightStyle := ssAbsolute;

  if UsesCardFooter then
  begin
    asm
      var root = document.getElementById('csy_widget_' + this.FDashboardId);
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      var tableHost = document.getElementById(this.FSummaryGrid.ElementID);
      var tableHeight = lTableHeight;

      if (root) {
        root.classList.remove('csy-chart-summary-fixed');
      }
      if (footer) {
        footer.style.display = 'block';
      }
      if (footer && tableHost && !footer.contains(tableHost)) {
        footer.appendChild(tableHost);
      }
      if (tableHost) {
        tableHost.style.height = tableHeight + 'px';
        tableHost.style.minHeight = tableHeight + 'px';
        tableHost.style.maxHeight = tableHeight + 'px';
        tableHost.style.overflowY = 'auto';
        tableHost.style.overflowX = 'hidden';
        tableHost.style.width = '100%';
        tableHost.style.display = 'block';
        tableHost.style.position = 'relative';
      }
    end;
  end
  else
  begin
    asm
      var root = document.getElementById('csy_widget_' + this.FDashboardId);
      var body = document.getElementById('csy_body_' + this.FDashboardId);
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      var tableHost = document.getElementById(this.FSummaryGrid.ElementID);
      var tableHeight = lTableHeight;

      if (root) {
        root.classList.remove('csy-chart-summary-fixed');
        root.style.setProperty('--csy-summary-height', tableHeight + 'px');
      }
      if (footer) {
        footer.style.display = 'none';
      }
      if (body && tableHost && !body.contains(tableHost)) {
        body.appendChild(tableHost);
      }
      if (tableHost) {
        tableHost.style.height = tableHeight + 'px';
        tableHost.style.minHeight = tableHeight + 'px';
        tableHost.style.maxHeight = tableHeight + 'px';
        tableHost.style.overflowY = 'auto';
        tableHost.style.width = '100%';
        tableHost.style.display = 'block';
        tableHost.style.position = 'relative';
      }
    end;
  end;
end;

procedure TBaseDashboardItem.EnsureCardChromeClasses;
var
  lHasChart: Boolean;
  lHasSummaryTable: Boolean;
  lUsesFooter: Boolean;
begin
  lHasChart := GetChartHeight > 0;
  lHasSummaryTable := ShouldShowFullSummaryTable or UsesComboRowSummary or IsDrillDownComboEnabled;
  if Assigned(FSummaryGrid) and FSummaryGrid.Visible then
    lHasSummaryTable := True;
  lUsesFooter := UsesCardFooter;
  if lHasChart then
    ElementClassName := 'csy-dashboard-widget-col card shadow-sm csy-dashboard-card csy-has-chart mb-0'
  else
    ElementClassName := 'csy-dashboard-widget-col card shadow-sm csy-dashboard-card csy-has-table mb-0';

  asm
    var root = document.getElementById(this.ElementID);
    if (!root) {
      return;
    }
    root.classList.add('card', 'shadow-sm', 'csy-dashboard-card', 'csy-dashboard-widget-col', 'mb-0');
    root.classList.remove('csy-widget-full-width');
    if (lHasChart) {
      root.classList.add('csy-has-chart');
    } else {
      root.classList.remove('csy-has-chart');
    }
    if (lHasSummaryTable) {
      root.classList.add('csy-has-table');
    } else {
      root.classList.remove('csy-has-table');
    }
    root.style.height = 'auto';
    root.style.minHeight = '0';
    root.style.overflow = 'visible';
    root.style.position = 'relative';
    root.style.width = '100%';
    root.style.maxWidth = '100%';
    root.style.boxSizing = 'border-box';
    root.style.display = 'flex';
    root.style.flexDirection = 'column';
  end;

  if lUsesFooter then
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.add('csy-uses-footer');
      }
    end;
    LockChartSummaryFooterLayout;
  end
  else
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.remove('csy-uses-footer');
      }
    end;
  end;

  if UsesChartSummaryFixedHeight and lUsesFooter then
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.add('csy-chart-summary-fixed');
        root.classList.remove('csy-chart-only');
      }
    end;
  end
  else
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.remove('csy-chart-summary-fixed');
      }
    end;
  end;

  if IsChartOnlyWidget then
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.add('csy-chart-only');
        root.classList.remove('csy-chart-summary-fixed', 'csy-uses-footer');
      }
    end;
  end
  else
  begin
    asm
      var root = document.getElementById(this.ElementID);
      if (root) {
        root.classList.remove('csy-chart-only');
      }
    end;
  end;
end;

procedure TBaseDashboardItem.ApplyCardChrome(const ATitle: string);
begin
  FTitle := ATitle;
  EnsureCardHeader;
  CreateTitleLabel;
  SetTitle(ATitle);
  EnsureCardChromeClasses;
  NormalizeWidgetLayout;
end;

procedure TBaseDashboardItem.CancelWidgetSkeletonTimer;
begin
  asm
    var root = document.getElementById(this.ElementID);
    if (root && root.dataset.csySkeletonTimer) {
      window.clearTimeout(parseInt(root.dataset.csySkeletonTimer, 10));
      root.dataset.csySkeletonTimer = '';
    }
  end;
end;

procedure TBaseDashboardItem.RemoveAllLoadingOverlays;
begin
  if Assigned(FLoadingPanel) then
    FLoadingPanel.Visible := False;
end;

procedure TBaseDashboardItem.StripWidgetLoadingChrome;
begin
  if Assigned(FLoadingPanel) and FLoadingPanel.Visible then
    Exit;
  asm
    function stripLoadingText(root) {
      if (!root) {
        return;
      }
      Array.prototype.slice.call(root.childNodes).forEach(function(node) {
        if (node.nodeType === 3 && /^loading/i.test(String(node.textContent || '').trim())) {
          node.textContent = '';
        }
      });
      root.querySelectorAll('.csy-widget-loading-text').forEach(function(el) {
        if (!el.closest('.csy-widget-skeleton')) {
          el.remove();
        }
      });
      root.querySelectorAll('*').forEach(function(el) {
        if (el.classList && (el.classList.contains('csy-widget-skeleton') ||
            el.classList.contains('csy-widget-loading-text'))) {
          return;
        }
        var text = String(el.textContent || '').trim();
        if (/^loading/i.test(text) && el.children.length <= 1) {
          el.textContent = '';
        }
      });
    }

    var root = document.getElementById(this.ElementID);
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    var footer = document.getElementById('csy_footer_' + this.FDashboardId);
    [root, body, footer].forEach(function(el) {
      if (!el) {
        return;
      }
      stripLoadingText(el);
      el.querySelectorAll('[id^="csy_chart_"], .card-body-chart, .csy-card-footer').forEach(stripLoadingText);
    });
  end;
end;

procedure TBaseDashboardItem.ShowDataSkeleton;
begin
  EnsureLoadingOverlay;

  if Assigned(FLoadingPanel) then
    FLoadingPanel.Visible := True;
  if Assigned(FLoadingLabel) then
    FLoadingLabel.Visible := True;
  if Assigned(FChartPanel) then
    FChartPanel.Visible := True;

  asm
    var root = document.getElementById(this.ElementID);
    if (!root) {
      root = document.getElementById('csy_widget_' + this.FDashboardId);
    }
    if (root) {
      root.setAttribute('data-csy-loading', '1');
      root.removeAttribute('data-csy-loaded');
    }
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    var loading = document.getElementById('csy_loading_' + this.FDashboardId);
    if (body && loading) {
      if (loading.parentElement !== body) {
        body.appendChild(loading);
      }
      body.style.position = 'relative';
      body.style.overflow = 'hidden';
      loading.style.display = 'flex';
      loading.style.zIndex = '10';
      if (root && root.classList.contains('csy-has-chart')) {
        var chartHeight = getComputedStyle(document.documentElement)
          .getPropertyValue('--csy-chart-height').trim() || '340px';
        body.style.height = chartHeight;
        body.style.minHeight = chartHeight;
      }
    }
  end;
end;

procedure TBaseDashboardItem.EnsureChartReadyForRender;
begin
  if Assigned(FChartPanel) then
    FChartPanel.Visible := True;
  RestoreChartPanelVisibility;
end;

procedure TBaseDashboardItem.RestoreChartPanelVisibility;
begin
  if Trim(FChartCanvasId) = '' then
    Exit;

  asm
    var body = document.getElementById('csy_body_' + this.FDashboardId);
    var panel = document.getElementById(this.FChartCanvasId + '_panel');
    var canvas = document.getElementById(this.FChartCanvasId);

    if (panel) {
      panel.style.visibility = '';
      panel.style.display = '';
      panel.removeAttribute('data-csy-hidden-for-load');
      panel.removeAttribute('aria-hidden');
    }
    if (canvas) {
      canvas.style.visibility = '';
      canvas.style.display = '';
    }
    if (body) {
      body.querySelectorAll('[id^="csy_chart_"], .card-body-chart').forEach(function(el) {
        el.style.visibility = '';
        el.style.display = '';
        el.removeAttribute('data-csy-hidden-for-load');
        el.removeAttribute('aria-hidden');
      });
    }
  end;
end;

procedure TBaseDashboardItem.FinalizeChartLayout;
begin
  if Assigned(FLoadingPanel) and FLoadingPanel.Visible then
    Exit;

  RestoreChartPanelVisibility;
  ApplyChartPanelHeight;
  StripWidgetLoadingChrome;
  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (canvas && canvas.__csyChart && typeof canvas.__csyChart.resize === 'function') {
      canvas.__csyChart.resize();
    }
  end;
end;

procedure TBaseDashboardItem.HideDataSkeleton;
begin
  CancelWidgetSkeletonTimer;
  if Assigned(FLoadingPanel) then
    FLoadingPanel.Visible := False;
  if Assigned(FLoadingLabel) then
    FLoadingLabel.Visible := False;
  if Assigned(FChartPanel) then
    FChartPanel.Visible := True;
  RestoreChartPanelVisibility;
  ApplyChartPanelHeight;
  asm
    var root = document.getElementById(this.ElementID);
    if (!root) {
      root = document.getElementById('csy_widget_' + this.FDashboardId);
    }
    var loading = document.getElementById('csy_loading_' + this.FDashboardId);
    if (loading) {
      loading.style.display = 'none';
    }
    if (root) {
      root.removeAttribute('data-csy-loading');
      root.setAttribute('data-csy-loaded', '1');
      root.querySelectorAll('[data-csy-hidden-for-load="1"]').forEach(function(panel) {
        panel.style.visibility = '';
        panel.style.display = '';
        panel.removeAttribute('data-csy-hidden-for-load');
        panel.removeAttribute('aria-hidden');
      });
      root.querySelectorAll('[id^="csy_chart_"], .card-body-chart').forEach(function(panel) {
        panel.style.visibility = '';
        panel.style.display = '';
        panel.removeAttribute('data-csy-hidden-for-load');
        panel.removeAttribute('aria-hidden');
      });
    }
    var canvas = document.getElementById(this.FChartCanvasId);
    if (canvas && canvas.__csyChart && typeof canvas.__csyChart.resize === 'function') {
      canvas.__csyChart.resize();
    }
  end;
end;

procedure TBaseDashboardItem.ShowErrorState;
begin
  CancelWidgetSkeletonTimer;
  if Assigned(FLoadingPanel) then
    FLoadingPanel.Visible := False;
  RestoreChartPanelVisibility;
  asm
    var loading = document.getElementById('csy_loading_' + this.FDashboardId);
    if (loading) {
      loading.style.display = 'none';
    }
    var root = document.getElementById(this.ElementID);
    if (!root) {
      return;
    }
    root.removeAttribute('data-csy-loading');
    root.setAttribute('data-csy-loaded', '1');
    root.querySelectorAll('[data-csy-hidden-for-load="1"]').forEach(function(panel) {
      panel.style.visibility = '';
      panel.style.display = '';
      panel.removeAttribute('data-csy-hidden-for-load');
      panel.removeAttribute('aria-hidden');
    });

    var err = document.getElementById(this.ElementID + '_error');
    if (!err) {
      err = document.createElement('div');
      err.id = this.ElementID + '_error';
      err.className = 'csy-widget-error m-2';
      err.textContent = 'Unable to load widget data.';
      root.appendChild(err);
    }
  end;
end;

function TBaseDashboardItem.GetEffectiveChartJson: string;
begin
  Result := Trim(FChartData);
  if (Result = '') or (Result = '[]') then
    Result := Trim(FSummaryData);
end;

function TBaseDashboardItem.HasChartData(const ADataJSON: string): Boolean;
var
  lTrimmed: string;
  lArr: TJSArray;
begin
  lTrimmed := Trim(ADataJSON);
  if (lTrimmed = '') or (lTrimmed = '[]') then
    Exit(False);

  try
    lArr := TJSArray(TJSJSON.parse(lTrimmed));
    Result := Assigned(lArr) and (lArr.Length > 0);
  except
    Result := False;
  end;
end;

function TBaseDashboardItem.HasRenderedChart: Boolean;
begin
  if Trim(FChartCanvasId) = '' then
    Exit(False);

  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    Result = !!(canvas && canvas.__csyChart);
  end;
end;

function TBaseDashboardItem.HasDisplayedContent: Boolean;
begin
  Result := False;

  asm
    var err = document.getElementById(this.ElementID + '_error');
    if (err) {
      Result = true;
    }
  end;
  if Result then
    Exit;

  if HasRenderedChart then
    Exit(True);

  if Assigned(FSummaryGrid) and (FSummaryGrid.RowCount > 1) then
    Exit(True);

  asm
    var summary = document.getElementById('csy_summary_' + this.FDashboardId);
    if (summary) {
      var table = summary.tagName === 'TABLE' ? summary : summary.querySelector('table');
      if (table && table.rows && table.rows.length > 1) {
        Result = true;
      }
    }
    if (!Result && this.FChartCanvasId) {
      var panel = document.getElementById(this.FChartCanvasId + '_panel');
      if (panel && panel.querySelector('.csy-chart-empty')) {
        Result = true;
      }
    }
  end;
end;

function TBaseDashboardItem.CanEndLoadingOverlay: Boolean;
begin
  Result := False;

  asm
    var err = document.getElementById(this.ElementID + '_error');
    if (err) {
      Result = true;
    }
  end;
  if Result then
    Exit;

  if RequiresChart then
  begin
    if HasRenderedChart then
      Exit(True);
    asm
      if (this.FChartCanvasId) {
        var panel = document.getElementById(this.FChartCanvasId + '_panel');
        if (panel && panel.querySelector('.csy-chart-empty')) {
          Result = true;
        }
      }
    end;
    Exit;
  end;

  Result := HasDisplayedContent;
end;

function TBaseDashboardItem.RequiresChart: Boolean;
begin
  Result := GetChartHeight > 0;
end;

procedure TBaseDashboardItem.EnsureChartCanvas;
begin
  asm
    var panel = document.getElementById(this.FChartCanvasId + '_panel');
    if (!panel) {
      return;
    }

    var canvas = document.getElementById(this.FChartCanvasId);
    if (!canvas) {
      panel.innerHTML = "";
      canvas = document.createElement("canvas");
      canvas.id = this.FChartCanvasId;
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      panel.appendChild(canvas);
    }
  end;
end;
procedure TBaseDashboardItem.CreateComponents;
begin
  CreateTitleLabel;
end;


procedure TBaseDashboardItem.CreateTitleLabel;
begin
  EnsureCardHeader;
  if not assigned(FTitleLabel) then
  begin
    FTitleLabel := TLabel.Create(Self);
    FTitleLabel.Parent := FCardHeaderPanel;
    FTitleLabel.Font.Size := 14;
    FTitleLabel.Font.Style := [fsBold];
    FTitleLabel.ElementPosition := epRelative;
    FTitleLabel.ElementID := 'csy_title_' + IntToStr(FDashboardId);
    FTitleLabel.ElementClassName := 'csy-widget-title mb-0';
    FTitleLabel.WidthPercent := 100;
    FTitleLabel.WidthStyle := ssAuto;
    FTitleLabel.HeightStyle := ssAuto;
    FTitleLabel.OnClick := TestClick;
  end;
end;

procedure TBaseDashboardItem.CreateComboBox;
begin
  if UsesChartHoverSummary or not ShowSummaryCombo then
    Exit;

  EnsureCardHeader;
  if not Assigned(FComboBox) then
  begin
    FComboBox := TComboBox.Create(Self);
    FComboBox.Parent := FCardHeaderPanel;
    FComboBox.Align := alTop;
    FComboBox.ElementPosition := epRelative;
    FComboBox.ElementID := 'csy_combo_' + IntToStr(FDashboardId);
    FComboBox.ElementClassName := 'csy-widget-select';
    FComboBox.WidthPercent := 100;
    FComboBox.WidthStyle := ssAuto;
    FComboBox.OnChange := ComboBoxChange;
    UpdateSummaryComboVisibility;
  end;
end;

procedure TBaseDashboardItem.RemoveSummaryCombo;
var
  lElementId: string;
begin
  lElementId := 'csy_combo_' + IntToStr(FDashboardId);
  asm
    var el = document.getElementById(lElementId);
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  end;

  if Assigned(FComboBox) then
    FreeAndNil(FComboBox);
end;

procedure TBaseDashboardItem.HideSummaryCombo;
begin
  if not Assigned(FComboBox) then
    Exit;

  FComboBox.Visible := False;
  asm
    var el = document.getElementById(this.FComboBox.ElementID);
    if (el) {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.height = '0';
      el.style.minHeight = '0';
      el.style.margin = '0';
      el.style.padding = '0';
      el.style.border = 'none';
      el.setAttribute('aria-hidden', 'true');
    }
  end;
end;

procedure TBaseDashboardItem.UpdateSummaryComboVisibility;
begin
  if not Assigned(FComboBox) then
    Exit;

  if ShowSummaryCombo and (FComboBox.Items.Count > 0) then
  begin
    FComboBox.Visible := True;
    asm
      var el = document.getElementById(this.FComboBox.ElementID);
      if (el) {
        el.style.display = '';
        el.style.visibility = '';
        el.style.height = '';
        el.style.minHeight = '';
        el.style.margin = '';
        el.style.padding = '';
        el.removeAttribute('aria-hidden');
      }
    end;
  end
  else
    HideSummaryCombo;
end;

function TBaseDashboardItem.GetEffectiveDrillDownFieldName: string;
begin
  Result := Trim(FConfiguration.DrillDownFieldName);
  if Result <> '' then
    Exit;
  Result := GetComboFieldName;
end;

procedure TBaseDashboardItem.PopulateComboBox;
var
  lData: string;
  lMainDataArray: JS.TJSArray;
  lColumnData: JS.TJSObject;
  lChartData: string;
  lIdx: integer;
begin
  if not ShowSummaryCombo then
  begin
    RemoveSummaryCombo;
    Exit;
  end;

  if not Assigned(FComboBox) then
    Exit;

  FComboBox.Clear;

  if Trim(FChartData) = '' then
    Exit;

  lChartData := FChartData;
  lMainDataArray := JS.toArray(TJSJSON.parse(lChartData));
  if lMainDataArray.Length = 0 then
    Exit;

  for lIdx := 0 to lMainDataArray.Length-1 do
  begin
    lData := GetChartRowFieldValue(lIdx, GetEffectiveDrillDownFieldName);
    if lData <> '' then
      FComboBox.Items.Add(lData);
  end;

  if FComboBox.Items.Count > 0 then
    FComboBox.ItemIndex := 0;

  UpdateSummaryComboVisibility;
end;


procedure TBaseDashboardItem.DisplayData;
begin
  if IsDrillDownComboEnabled then
    await(DisplayDrillDownWithCombo)
  else
  begin
    RemoveSummaryCombo;
    if GetChartHeight > 0 then
    begin
      if HasChartData(FChartData) then
        AddChartAndData(FChartData)
      else
        ShowChartNoData;
    end;
  end;
end;

function TBaseDashboardItem.IsDrillDownComboEnabled: Boolean;
begin
  Result := RequiresSqlDrillDownSummary;
end;

procedure TBaseDashboardItem.EnsureDrillDownSQLLoaded(const AResponse: TDashboardResponse);
begin
  FDrillDownSQL := Trim(AResponse.DrillDownSQL);
  if FDrillDownSQL = '' then
    FDrillDownSQL := Trim(FConfiguration.DrilDownSQL);
  // Daily Trading Pattern keeps drill-down SQL in template SQLSummary.
  if (FDrillDownSQL = '') and Assigned(FTemplate) then
    FDrillDownSQL := Trim(FTemplate.SQLSummary);

  if FDrillDownSQL = '' then
    Exit;

  // Resolve dashboard params when the response did not already ship resolved SQL.
  if Trim(AResponse.DrillDownSQL) = '' then
    FDrillDownSQL := ResolveSqlParameters(FDrillDownSQL);
end;

function TBaseDashboardItem.ResolveSqlParameters(const ASQL: string): string;
begin
  Result := ASQL;
  if Trim(Result) = '' then
    Exit;

  asm
    var sql = ASQL;
    var paramsObj = null;
    try {
      if (this.FDashboardParameters && this.FDashboardParameters.length > 2) {
        paramsObj = JSON.parse(this.FDashboardParameters);
      }
    } catch (e) {
      paramsObj = null;
    }
    if (paramsObj) {
      for (var key in paramsObj) {
        if (!Object.prototype.hasOwnProperty.call(paramsObj, key)) {
          continue;
        }
        var val = paramsObj[key];
        if (val === null || val === undefined) {
          continue;
        }
        var replacement = String(val);
        if ((key !== 'BranchId') && (key !== 'DayLikeForLike')) {
          replacement = "'" + replacement + "'";
        }
        sql = sql.replace(new RegExp('@' + key, 'gi'), replacement);
      }
    }
    Result = sql;
  end;
end;

procedure TBaseDashboardItem.EnsureSummaryGridVisible;
var
  lSummaryParent: TPanel;
begin
  lSummaryParent := GetSummaryTableParentPanel;
  if Assigned(FSummaryGrid) then
  begin
    FSummaryGrid.Visible := True;
    FSummaryGrid.Parent := lSummaryParent;
  end;

  if UsesCardFooter then
  begin
    asm
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      var summary = document.getElementById('csy_summary_' + this.FDashboardId);
      if (footer) {
        footer.style.display = 'block';
      }
      if (summary && footer) {
        var scrollWrap = footer.querySelector('.csy-summary-scroll-wrap');
        if (scrollWrap && scrollWrap.contains(summary)) {
          footer.insertBefore(summary, scrollWrap);
          scrollWrap.remove();
        }
        if (!footer.contains(summary)) {
          footer.appendChild(summary);
        }
        summary.style.display = 'block';
        summary.style.visibility = 'visible';
        summary.style.position = 'relative';
        summary.style.left = '0';
        summary.style.top = '0';
        summary.style.width = '100%';
        summary.style.maxWidth = '100%';
      }
    end;
  end
  else
  begin
    asm
      var footer = document.getElementById('csy_footer_' + this.FDashboardId);
      var body = document.getElementById('csy_body_' + this.FDashboardId);
      var summary = document.getElementById('csy_summary_' + this.FDashboardId);
      if (footer) {
        footer.style.display = 'none';
      }
      if (summary) {
        if (body && !body.contains(summary)) {
          body.appendChild(summary);
        }
        summary.style.position = 'relative';
        summary.style.left = 'auto';
        summary.style.top = 'auto';
        summary.style.width = '100%';
        summary.style.maxWidth = '100%';
        summary.style.display = 'block';
        summary.style.visibility = 'visible';
        summary.style.height = 'auto';
        summary.style.minHeight = '28px';
      }
    end;
  end;
end;

procedure TBaseDashboardItem.HideSummaryGridIfEmpty;
begin
  if Assigned(FSummaryGrid) then
    FSummaryGrid.Visible := False;

  asm
    var summary = document.getElementById('csy_summary_' + this.FDashboardId);
    if (summary) {
      summary.style.display = 'none';
    }
  end;
  SyncCardFooterVisibility;
  EnsureCardChromeClasses;
end;

function TBaseDashboardItem.IsDayLikeForLikeWidget: Boolean;
begin
  Result := Pos('day like for like', LowerCase(Trim(FTitle))) > 0;
end;

function TBaseDashboardItem.IsChartOnlyWidget: Boolean;
begin
  Result := SameText(Trim(FTitle), 'LFL Yearly Profit Comparison');
end;

function TBaseDashboardItem.IsTradingPatternWidget: Boolean;
begin
  Result := Pos('trading pattern', LowerCase(Trim(FTitle))) > 0;
end;

function TBaseDashboardItem.RequiresSqlDrillDownSummary: Boolean;
begin
  // Only Top5 uses the SQL drill-down combo/summary path.
  // SQLSingleSummary historically shared the SummaryIncluded display path.
  Result := FDrillDownPresent and Assigned(FTemplate) and
    SameText(FTemplate.DashboardItemType, 'SQLSummaryTop5');
end;

function TBaseDashboardItem.RequiresConfigDrillDownSummary: Boolean;
begin
  if RequiresSqlDrillDownSummary then
    Exit(False);

  // Hourly/Monthly embed summary metrics in chart rows. Daily does not —
  // its metrics come from SQLSummary / config drill-down on TransDate.
  if IsTradingPatternWidget and
     not SameText(Trim(FTitle), 'Daily Trading Pattern') then
    Exit(False);

  Result := (Trim(FConfiguration.DrillDownFieldName) <> '') and
    ((Trim(FConfiguration.DrilDownSQL) <> '') or (Trim(FDrillDownSQL) <> '') or
     (Assigned(FTemplate) and (Trim(FTemplate.SQLSummary) <> '')));
end;

function TBaseDashboardItem.GetComboFieldName: string;
var
  lLabels: TJSArray;
begin
  Result := Trim(FConfiguration.DrillDownFieldName);
  if Result <> '' then
    Exit;

  if Trim(FConfiguration.XValueLabels) = '' then
    Exit;

  try
    lLabels := TJSArray(TJSJSON.parse(FConfiguration.XValueLabels));
    if lLabels.Length > 0 then
      Result := Trim(string(lLabels[0]));
  except
    Result := '';
  end;
end;

function TBaseDashboardItem.UsesComboRowSummary: Boolean;
begin
  if GetChartHeight <= 0 then
    Exit(False);
  if RequiresSqlDrillDownSummary then
    Exit(False);
  if IsChartOnlyWidget then
    Exit(False);
  if IsDayLikeForLikeWidget then
    Exit(False);

  if IsTradingPatternWidget then
  begin
    if Length(FConfiguration.SummaryFields) > 0 then
      Exit(True);
    Exit(HasChartData(FChartData) or HasChartData(FSummaryData));
  end;

  if Trim(GetComboFieldName) = '' then
    Exit(False);

  Result := FFullSummary or
    SameText(FSummaryType, 'SummaryIncludedIndividual') or
    (FSummaryType = '');
end;

procedure TBaseDashboardItem.EnsureSummaryFieldsReady(const ADataJSON: string);
var
  lArr: TJSArray;
  lField: TSummaryArray;
  lIdx: Integer;
  lKey: string;
  lKeysJson: string;
begin
  if Length(FConfiguration.SummaryFields) > 0 then
    Exit;

  if Assigned(FTemplate) and (Trim(FTemplate.Configuration) <> '') then
    LoadConfigurationFromJSON(FTemplate.Configuration);

  if Length(FConfiguration.SummaryFields) > 0 then
    Exit;

  if Trim(ADataJSON) = '' then
    Exit;

  try
    lArr := TJSArray(TJSJSON.parse(ADataJSON));
  except
    Exit;
  end;

  if lArr.Length = 0 then
    Exit;

  lKeysJson := '';
  asm
    var rows = lArr;
    if (!rows || rows.length === 0) {
      return;
    }
    var row = rows[0];
    if (!row) {
      return;
    }
    lKeysJson = JSON.stringify(Object.keys(row));
  end;

  if Trim(lKeysJson) = '' then
    Exit;

  try
    lArr := TJSArray(TJSJSON.parse(lKeysJson));
  except
    Exit;
  end;

  if lArr.Length = 0 then
    Exit;

  SetLength(FConfiguration.SummaryFields, lArr.Length);
  for lIdx := 0 to lArr.Length - 1 do
  begin
    lKey := Trim(string(lArr[lIdx]));
    if lKey = '' then
      Continue;

    lField := TSummaryArray.Create;
    lField.SearchName := lKey;
    lField.ToField := lKey;
    lField.DisplayName := StringReplace(lKey, '_', ' ', [rfReplaceAll]);
    lField.FieldType := 'Str';
    FConfiguration.SummaryFields[lIdx] := lField;
  end;

  FSummaryFieldCount := Length(FConfiguration.SummaryFields);
end;

function TBaseDashboardItem.ShouldShowFullSummaryTable: Boolean;
begin
  if GetChartHeight <= 0 then
    Exit(True);
  if RequiresSqlDrillDownSummary then
    Exit(False);
  if UsesComboRowSummary then
    Exit(False);
  if IsChartOnlyWidget then
    Exit(False);
  if Length(FConfiguration.SummaryFields) = 0 then
    Exit(False);

  if IsDayLikeForLikeWidget then
    Exit(True);

  Result := FConfiguration.SummaryTablePresent or FSummaryPresent or
    SameText(FSummaryType, 'SummaryIncludedList');
end;

function TBaseDashboardItem.GetSummaryFieldValue(ARowData: JS.TJSObject;
  AFieldIndex: Integer): string;
var
  lField: TSummaryArray;
  lColumnName: string;
begin
  Result := '';
  if not Assigned(ARowData) then
    Exit;
  if (AFieldIndex < 0) or (AFieldIndex >= Length(FConfiguration.SummaryFields)) then
    Exit;

  lField := FConfiguration.SummaryFields[AFieldIndex];
  if lField.ToField <> '' then
    Result := Trim(String(TJSObject(ARowData)[lField.ToField]));
  if (Result = '') or SameText(Result, 'undefined') or SameText(Result, 'null') then
  begin
    lColumnName := ResolveSummaryColumnName(AFieldIndex, 0);
    if (lColumnName <> '') and not SameText(lColumnName, lField.ToField) then
      Result := Trim(String(TJSObject(ARowData)[lColumnName]));
  end;
  if (Result = '') or SameText(Result, 'undefined') or SameText(Result, 'null') then
    Result := Trim(String(TJSObject(ARowData)[lField.SearchName]));
  if SameText(Result, 'undefined') or SameText(Result, 'null') then
    Result := '';
end;

function TBaseDashboardItem.GetSummaryFieldValueAtIteration(ARowData: JS.TJSObject;
  AFieldIndex, AIterationIndex: Integer): string;
var
  lColumnName: string;
begin
  Result := '';
  if not Assigned(ARowData) then
    Exit;

  lColumnName := ResolveSummaryColumnName(AFieldIndex, AIterationIndex);
  if lColumnName <> '' then
    Result := Trim(String(TJSObject(ARowData)[lColumnName]));
  if (Result = '') or SameText(Result, 'undefined') or SameText(Result, 'null') then
    Result := GetSummaryFieldValue(ARowData, AFieldIndex);
end;

function TBaseDashboardItem.ExtractChartRowJson(const ADataJSON: string;
  ARowIndex: Integer): string;
var
  lArr: TJSArray;
begin
  Result := '[]';
  if Trim(ADataJSON) = '' then
    Exit;

  try
    lArr := TJSArray(TJSJSON.parse(ADataJSON));
    if (ARowIndex < 0) or (ARowIndex >= lArr.Length) then
      Exit;
    Result := '[' + string(TJSJSON.stringify(TJSObject(lArr[ARowIndex]))) + ']';
  except
    Result := '[]';
  end;
end;

procedure TBaseDashboardItem.PopulateComboRowTable(ARowIndex: Integer);
var
  I: Integer;
begin
  if Length(FConfiguration.SummaryFields) = 0 then
    EnsureSummaryFieldsReady(GetEffectiveChartJson);
  if Length(FConfiguration.SummaryFields) = 0 then
    Exit;

  CreateSummaryFieldsTableRowIndex(GetEffectiveChartJson, ARowIndex);

  if Assigned(FSummaryGrid) then
    for I := 0 to Length(FConfiguration.SummaryFields) - 1 do
      FSummaryGrid.Cells[I, 0] := FConfiguration.SummaryFields[I].DisplayName;

  ApplyWidgetTableHeaderStyles;
  ConfigureSummaryTableInteraction;
  EnsureSummaryGridVisible;
  EnsureCardChromeClasses;
  ApplySummaryTableLayout;
  LockChartSummaryFooterLayout;
  UpdateChartSelectionHighlight(ARowIndex);
end;

procedure TBaseDashboardItem.DisplayComboRowSummary;
begin
  if not HasChartData(GetEffectiveChartJson) then
  begin
    HideSummaryGridIfEmpty;
    Exit;
  end;

  EnsureSummaryFieldsReady(GetEffectiveChartJson);
  if Length(FConfiguration.SummaryFields) = 0 then
  begin
    HideSummaryGridIfEmpty;
    Exit;
  end;

  RemoveSummaryCombo;
  if FSummaryIndex < 0 then
    FSummaryIndex := 0;

  if RequiresDrillDownSQL then
    await(LoadChartRowDrillDownSummary(FSummaryIndex))
  else
    await(HandleChartRowHover(FSummaryIndex));
  StoreChartHoverMetadata;
  if UsesChartHoverSummary then
    EnsureChartHoverHandlers;
  ApplyLayoutSettings;
end;

function TBaseDashboardItem.FormatDrillDownParameterValue(const AFieldName,
  AValue: string): string;
begin
  Result := AValue;
  if (Pos('date', LowerCase(AFieldName)) > 0) or (Pos('/', Result) > 0) then
    Result := StringReplace(Result, '/', '.', [rfReplaceAll]);
end;

function TBaseDashboardItem.ReplaceDrillDownPlaceholder(const ASQL, AFieldName,
  AValue: string): string;
var
  lPlaceholder: string;
  lQuotedPlaceholder: string;
  lReplacement: string;
  lSqlLower: string;
begin
  Result := ASQL;
  if Trim(Result) = '' then
    Exit;

  lPlaceholder := '@' + AFieldName;
  lReplacement := Trim(FormatDrillDownParameterValue(AFieldName, AValue));
  if (Length(lReplacement) >= 2) and (lReplacement[1] = '''') and
     (lReplacement[Length(lReplacement)] = '''') then
    lReplacement := Copy(lReplacement, 2, Length(lReplacement) - 2);

  lReplacement := StringReplace(lReplacement, '''', '''''', [rfReplaceAll]);
  lQuotedPlaceholder := '''' + lPlaceholder + '''';
  lSqlLower := LowerCase(Result);
  // Case-insensitive detect: SQL often uses @TRANDATE while config has TranDate.
  if Pos(LowerCase(lQuotedPlaceholder), lSqlLower) > 0 then
    Result := StringReplace(Result, lPlaceholder, lReplacement,
      [rfReplaceAll, rfIgnoreCase])
  else if Pos(LowerCase(lPlaceholder), lSqlLower) > 0 then
    Result := StringReplace(Result, lPlaceholder, '''' + lReplacement + '''',
      [rfReplaceAll, rfIgnoreCase]);
end;

procedure TBaseDashboardItem.DisplayDrillDownWithCombo;
begin
  RemoveSummaryCombo;

  if (GetChartHeight > 0) and HasChartData(GetEffectiveChartJson) then
    AddChartAndData(GetEffectiveChartJson)
  else if GetChartHeight > 0 then
    ShowChartNoData;

  if RequiresDrillDownSQL then
    await(LoadChartRowDrillDownSummary(FSummaryIndex))
  else
    await(HandleChartRowHover(FSummaryIndex));
  StoreChartHoverMetadata;
  if UsesChartHoverSummary then
    EnsureChartHoverHandlers;

  if not Assigned(FSummaryGrid) or (FSummaryGrid.RowCount <= 1) then
    HideSummaryGridIfEmpty;
  ApplyLayoutSettings;
  HideDataSkeleton;
end;

procedure TBaseDashboardItem.SetConfiguration;
//var
//  lConfigObj: JS.TJSObject;
//  lConfigJSON: string;
//  lParameters: TArray<string>;
begin
//  lConfigJSON := FTemplate.Configuration;
//  lConfigObj := JS.toObject(TJSJSON.parse(lConfigJSON));
//  FConfiguration := TDashboardItemConfig(lConfigObj);

//  lParameters := FConfiguration.Parameters;
end;

procedure TBaseDashboardItem.LoadConfigurationFromJSON(const AConfigJSON: string);
var
  lConfigObj: JS.TJSObject;
  lTrimmed: string;
begin
  if not Assigned(FConfiguration) then
    FConfiguration := TDashboardItemConfig.Create;

  lTrimmed := Trim(AConfigJSON);
  if (lTrimmed = '') or (lTrimmed = 'null') then
    Exit;

  try
    lConfigObj := JS.toObject(TJSJSON.parse(lTrimmed));
  except
    Exit;
  end;

  if not Assigned(lConfigObj) then
    Exit;

  try
    FConfiguration.Assign(lConfigObj);
    NormalizeConfigurationArrayFields(lConfigObj);
  except
    // Keep a usable empty config rather than failing widget creation.
  end;
end;

procedure TBaseDashboardItem.NormalizeConfigurationArrayFields(AConfigObj: JS.TJSObject);
var
  lSummaryFields: TJSArray;
begin
  if TJSArray.isArray(TJSObject(AConfigObj)['YValueName']) then
    FConfiguration.YValueName := string(JS.TJSJSON.stringify(TJSArray(TJSObject(AConfigObj)['YValueName'])));

  if TJSArray.isArray(TJSObject(AConfigObj)['XValueLabels']) then
    FConfiguration.XValueLabels := string(JS.TJSJSON.stringify(TJSArray(TJSObject(AConfigObj)['XValueLabels'])));

  if Length(FConfiguration.SummaryFields) = 0 then
  begin
    lSummaryFields := TJSArray(TJSObject(AConfigObj)['SummaryFields']);
    if not Assigned(lSummaryFields) then
      lSummaryFields := TJSArray(TJSObject(AConfigObj)['summaryFields']);
    if Assigned(lSummaryFields) and (lSummaryFields.Length > 0) then
      FConfiguration.Assign(AConfigObj);
  end;
end;

procedure TBaseDashboardItem.SetTemplate(ATemplate: TDashboardItemTemplate);
begin
  FTemplate := ATemplate;
  LoadConfigurationFromJSON(ATemplate.Configuration);
end;



procedure TBaseDashboardItem.ProcessResponse(AResponse: TDashboardResponse);
var
  lSummaryPayload: string;
begin
  LoadConfigurationFromJSON(AResponse.Configuration);

  FChartData := AResponse.GetChartPayload;
  FDrillDownPresent := AResponse.DrillDownPresent;
  FSummaryPresent := AResponse.SummaryPresent;
  FChartType := AResponse.ChartType;
  if (Trim(FChartType) = '') and Assigned(FTemplate) then
    FChartType := FTemplate.ChartType;
  FChartTypeFixed := AResponse.ChartTypeFixed;
  FSummaryType := AResponse.SummaryType;
  FFullSummary := AResponse.FullSummaryAvailable;
  if (Trim(FConfiguration.DrillDownFieldName) <> '') and not RequiresSqlDrillDownSummary then
    FFullSummary := True;

  lSummaryPayload := Trim(AResponse.GetSummaryPayload);
  if (lSummaryPayload <> '') and (lSummaryPayload <> '[]') then
    FSummaryData := lSummaryPayload
  else if not FDrillDownPresent then
  begin
    if (Trim(FChartData) <> '') and (Trim(FChartData) <> '[]') then
      FSummaryData := FChartData
    else
      FSummaryData := lSummaryPayload;
  end
  else
    FSummaryData := lSummaryPayload;

  FSummaryFieldCount := GetSummaryFieldCount;

  EnsureDrillDownSQLLoaded(AResponse);
end;

procedure TBaseDashboardItem.PrepareShell(const ATitle: string);
begin
  ApplyCardChrome(ATitle);
  EnsureCardBody;
  if (GetChartHeight > 0) and not IsChartOnlyWidget then
    EnsureCardFooter;
  CreateComponents;
  if Assigned(FChartPanel) then
  begin
    EnsureChartCanvas;
    UpdateChartPanelVisibility;
  end;
  SyncCardFooterVisibility;
  LockChartSummaryFooterLayout;
  ShowDataSkeleton;
end;

procedure TBaseDashboardItem.UpdateChartPanelVisibility;
begin
  if GetChartHeight <= 0 then
    Exit;
  if Assigned(FLoadingPanel) and FLoadingPanel.Visible then
    Exit;

  RestoreChartPanelVisibility;
end;

function TBaseDashboardItem.LoadData: TDashboardResponse;
begin
  Result := Await(SharedData.Dashboard.GetDashboardItem(FDashboardID.ToString, FDashboardParameters, FTemplate));
end;

procedure TBaseDashboardItem.ApplyData(AResponse: TDashboardResponse; const ADeferPresentation: Boolean);
var
  lTitle: string;
begin
  asm
    var err = document.getElementById(this.ElementID + '_error');
    if (err) {
      err.remove();
    }
  end;

  FResponse := AResponse;
  ProcessResponse(AResponse);
  CreateComponents;

  lTitle := Trim(AResponse.Title);
  if lTitle = '' then
    lTitle := FTitle;
  if (lTitle = '') and Assigned(FTemplate) then
    lTitle := FTemplate.Title;
  SetTitle(lTitle);
  RemoveSummaryCombo;
  await(DisplayData);
  HideDataSkeleton;
  UpdateChartPanelVisibility;
  if FSummaryFieldCount > 0 then
    EnsureCardChromeClasses;
  if ADeferPresentation then
    Exit
  else
    ApplyLayoutSettings;
end;

procedure TBaseDashboardItem.StageBulkData(AResponse: TDashboardResponse);
var
  lTitle: string;
begin
  asm
    var err = document.getElementById(this.ElementID + '_error');
    if (err) {
      err.remove();
    }
  end;

  FResponse := AResponse;
  ProcessResponse(AResponse);
  CreateComponents;

  lTitle := Trim(AResponse.Title);
  if lTitle = '' then
    lTitle := FTitle;
  if (lTitle = '') and Assigned(FTemplate) then
    lTitle := FTemplate.Title;
  SetTitle(lTitle);
  RemoveSummaryCombo;
  if FSummaryFieldCount > 0 then
    EnsureCardChromeClasses;
end;

procedure TBaseDashboardItem.PresentBulkData;
begin
  await(DisplayData);
  HideDataSkeleton;
  UpdateChartPanelVisibility;
  ApplyLayoutSettings;
  FinalizeChartLayout;
end;

procedure TBaseDashboardItem.LoadAndApply;
var
  lResponse: TDashboardResponse;
begin
  try
    if not HasRenderedChart then
      ShowDataSkeleton;
    lResponse := Await(LoadData);
    await(ApplyData(lResponse));
  except
    ShowErrorState;
  end;
  FIndividualFetchReason := '';
end;

function TBaseDashboardItem.Run: boolean;
begin
  try
    await(ApplyData(Await(LoadData)));
    Result := true;
  except
    Result := false;
  end;

  Title := FTitle;
end;

procedure TBaseDashboardItem.Refresh;
begin
  LoadAndApply;
end;



procedure TBaseDashboardItem.AddChartAndData(ADataJSON: string);
var
  lChartData: string;
begin
  if not assigned(FChartPanel) then
    CreateChart;

  RestoreChartPanelVisibility;

  lChartData := ADataJSON;
  if Trim(lChartData) = '' then
    lChartData := GetEffectiveChartJson;

  if not HasChartData(lChartData) then
  begin
    ShowChartNoData;
    Exit;
  end;

  asm
    var paramsObj = null;
    try {
      if (this.FDashboardParameters && this.FDashboardParameters.length > 2) {
        paramsObj = JSON.parse(this.FDashboardParameters);
        if (paramsObj && paramsObj.EndDate) {
          var endDate = new Date(paramsObj.EndDate);
          if (!isNaN(endDate.getTime())) {
            this.FYear = endDate.getFullYear();
          }
        }
      }
    } catch (e) {
    }
    if (!this.FYear) {
      this.FYear = new Date().getFullYear();
    }
  end;

  ResolveLegend;
  EnsureChartCanvas;
  EnsureChartReadyForRender;
  RenderChartJs(lChartData, FConfiguration.YValueName, FConfiguration.XValueLabels,
    FChartType, FConfiguration.LegendData, UsesChartHoverSummary);
  if UsesChartHoverSummary then
    UpdateChartSelectionHighlight(FSummaryIndex);
end;

procedure TBaseDashboardItem.ShowChartNoData;
begin
  if not Assigned(FChartPanel) then
    CreateChart;
  EnsureChartCanvas;
  EnsureChartReadyForRender;

  asm
    var panel = document.getElementById(this.FChartCanvasId + '_panel');
    if (!panel) {
      return;
    }
    panel.style.visibility = '';
    panel.style.display = '';
    panel.removeAttribute('data-csy-hidden-for-load');
    panel.removeAttribute('aria-hidden');
    panel.innerHTML = '<div class="csy-chart-empty text-muted px-3 py-4">No data for the selected date range.</div>';
  end;
  HideDataSkeleton;
end;

procedure TBaseDashboardItem.UpdateChartSelectionHighlight(AIndex: Integer);
begin
  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (!canvas || !canvas.__csyChart || !canvas.__csyHoverEnabled) {
      return;
    }
    if (typeof canvas.__csyApplyHighlight === 'function') {
      canvas.__csySelectedIndex = AIndex;
      canvas.__csyApplyHighlight(canvas.__csyChart, canvas, AIndex);
    }
  end;
end;

procedure TBaseDashboardItem.StoreChartHoverMetadata;
begin
  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (canvas) {
      canvas.__csyDashboardId = this.FDashboardId;
    }
  end;
end;

procedure TBaseDashboardItem.EnsureChartHoverTimer;
begin
  if Assigned(FChartHoverTimer) then
    Exit;

  FChartHoverTimer := TTimer.Create(Self);
  FChartHoverTimer.Interval := 40;
  FChartHoverTimer.OnTimer := ChartHoverTimerTick;
  FChartHoverTimer.Enabled := True;
end;

procedure TBaseDashboardItem.ChartHoverTimerTick(Sender: TObject);
var
  lIdx: Integer;
begin
  lIdx := -1;
  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (canvas && typeof canvas.__csyPendingHoverIndex === 'number' &&
        canvas.__csyPendingHoverIndex >= 0) {
      lIdx = canvas.__csyPendingHoverIndex;
    }
  end;

  if lIdx < 0 then
    Exit;

  await(HandleChartRowHover(lIdx));

  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (canvas) {
      canvas.__csyPendingHoverIndex = -1;
    }
  end;
end;

procedure TBaseDashboardItem.EnsureChartHoverHandlers;
begin
  EnsureChartHoverTimer;

  asm
    var canvas = document.getElementById(this.FChartCanvasId);
    if (!canvas || !canvas.__csyChart || !canvas.__csyHoverEnabled) {
      return;
    }
    if (canvas.__csyHoverBound) {
      return;
    }
    canvas.__csyHoverBound = true;
    canvas.__csyPendingHoverIndex = -1;

    canvas.addEventListener('click', function(evt) {
      if (!canvas.__csyHoverEnabled || canvas.__csyAxesOnly || !canvas.__csyChart) {
        return;
      }
      // intersect:false so near-zero bars (e.g. 8am) remain selectable by column
      var hits = canvas.__csyChart.getElementsAtEventForMode(
        evt, 'index', { intersect: false }, true);
      if (!hits || hits.length === 0) {
        return;
      }
      var idx = Math.floor(hits[0].index);
      if (idx < 0) {
        return;
      }
      canvas.__csySelectedIndex = idx;
      if (typeof canvas.__csyApplyHighlight === 'function') {
        canvas.__csyApplyHighlight(canvas.__csyChart, canvas, idx);
      }
      canvas.__csyPendingHoverIndex = idx;
    });
  end;
end;

function TBaseDashboardItem.GetChartRowFieldValue(ARowIndex: Integer;
  const AFieldName: string): string;
begin
  Result := '';
  if Trim(FChartData) = '' then
    Exit;
  if Trim(AFieldName) = '' then
    Exit;

  asm
    try {
      var rows = JSON.parse(this.FChartData || '[]');
      if (!rows || ARowIndex < 0 || ARowIndex >= rows.length) {
        return;
      }
      var row = rows[ARowIndex];
      if (!row) {
        return;
      }
      var fieldName = AFieldName;
      var val = row[fieldName];
      if (val === null || typeof val === 'undefined') {
        var target = String(fieldName).toLowerCase();
        for (var key in row) {
          if (!Object.prototype.hasOwnProperty.call(row, key)) {
            continue;
          }
          if (String(key).toLowerCase() === target) {
            val = row[key];
            break;
          }
        }
      }
      if (val === null || typeof val === 'undefined') {
        return;
      }
      Result = String(val).trim();
    } catch (e) {
      Result = '';
    }
  end;
end;

function TBaseDashboardItem.GetChartRowDrillDownParam(AIndex: Integer): string;
begin
  Result := Trim(GetChartRowFieldValue(AIndex, GetEffectiveDrillDownFieldName));
end;

procedure TBaseDashboardItem.HandleChartRowHover(AIndex: Integer);
begin
  if AIndex < 0 then
    Exit;

  RemoveSummaryCombo;
  FSummaryIndex := AIndex;

  if RequiresDrillDownSQL then
    await(ExecuteDrillDownForChartRow(AIndex))
  else
    PopulateComboRowTable(AIndex);

  EnsureSummaryGridVisible;
  EnsureCardChromeClasses;
  ApplySummaryTableLayout;
  LockChartSummaryFooterLayout;
end;

procedure TBaseDashboardItem.ExecuteDrillDownForChartRow(AIndex: Integer);
var
  lFieldName: string;
  lParamValue: string;
  lDrillDownSQL: string;
  lRanSql: Boolean;
begin
  if AIndex < 0 then
    Exit;

  FSummaryIndex := AIndex;
  lRanSql := False;

  // Same resolution path as RunSummary: load config/template SQL if needed, then
  // ReplaceDrillDownPlaceholder (handles '@Field' and '''@Field''' forms).
  if Trim(FDrillDownSQL) = '' then
  begin
    if Trim(FConfiguration.DrilDownSQL) <> '' then
      FDrillDownSQL := ResolveSqlParameters(Trim(FConfiguration.DrilDownSQL))
    else if Assigned(FTemplate) and (Trim(FTemplate.SQLSummary) <> '') then
      FDrillDownSQL := ResolveSqlParameters(Trim(FTemplate.SQLSummary));
  end;

  lFieldName := GetEffectiveDrillDownFieldName;
  lParamValue := GetChartRowDrillDownParam(AIndex);

  if (Trim(FDrillDownSQL) <> '') and (Trim(lFieldName) <> '') and
     (Trim(lParamValue) <> '') then
  begin
    lDrillDownSQL := ReplaceDrillDownPlaceholder(FDrillDownSQL, lFieldName, lParamValue);
    if not SameText(Trim(lDrillDownSQL), Trim(FDrillDownSQL)) then
    begin
      await(RunSummarySQL(lDrillDownSQL));
      // Treat as success only when the summary grid received values.
      lRanSql := Assigned(FSummaryGrid) and (FSummaryGrid.RowCount > 1) and
        (Trim(FSummaryGrid.Cells[0, 1]) <> '');
    end;
  end;

  // If SQL drill-down did not populate the footer, use the selected chart row.
  if not lRanSql then
    PopulateComboRowTable(AIndex);

  EnsureSummaryGridVisible;
  EnsureCardChromeClasses;
  ApplySummaryTableLayout;
  LockChartSummaryFooterLayout;
  UpdateChartSelectionHighlight(AIndex);
end;

procedure TBaseDashboardItem.LoadChartRowDrillDownSummary(AIndex: Integer);
begin
  if AIndex < 0 then
    Exit;

  FSummaryIndex := AIndex;
  RemoveSummaryCombo;

  if RequiresDrillDownSQL then
  begin
    if HasChartData(FSummaryData) then
    begin
      EnsureSummaryFieldsReady(FSummaryData);
      PopulateSummaryTableFromJson(FSummaryData, GetSummaryRowCount);
      UpdateChartSelectionHighlight(AIndex);
    end;
  end
  else
    PopulateComboRowTable(AIndex);

  EnsureSummaryGridVisible;
  EnsureCardChromeClasses;
  ApplySummaryTableLayout;
  LockChartSummaryFooterLayout;
end;

procedure TBaseDashboardItem.RenderChartJs(const ADataJSON, AYValueNames,
  AXLabelNames, AChartType: string; ALegendData: TArray<string>;
  AEnableHoverSelection: Boolean);
var
  lCurrencySymbol: string;
  lCurrencyFieldsJson: string;
begin
  lCurrencySymbol := GetCurrencySymbol;
  lCurrencyFieldsJson := BuildCurrencyFieldNamesJson;

  asm
    if (typeof Chart === "undefined") {
      console.error("Chart.js is not loaded.");
      return;
    }

    var canvas = document.getElementById(this.FChartCanvasId);
    if (!canvas) {
      return;
    }

    var currencySymbol = lCurrencySymbol;
    var currencyFields = [];
    try {
      currencyFields = JSON.parse(lCurrencyFieldsJson || "[]");
      if (!Array.isArray(currencyFields)) {
        currencyFields = [];
      }
    } catch (e) {
      currencyFields = [];
    }

    function isCurrencyField(fieldName) {
      if (!fieldName) {
        return false;
      }
      var key = String(fieldName).toLowerCase().replace(/[_\s]/g, "");
      if (/percent|pct/.test(key)) {
        return false;
      }
      if (/quantity|qty/.test(key)) {
        return false;
      }
      if (/visit/.test(key)) {
        return false;
      }
      if (/basket/.test(key)) {
        return false;
      }
      if (/transaction/.test(key) && key.indexOf("amount") < 0) {
        return false;
      }
      if (/discount/.test(key)) {
        return false;
      }
      if (/profit|sellnet|cashsellnet|costnet|taking|refund|spend/.test(key)) {
        return true;
      }
      if (/sales/.test(key) && key.indexOf("quantity") < 0) {
        return true;
      }
      if (key === "sales" || key === "sell") {
        return true;
      }
      return currencyFields.some(function(field) {
        return String(field).toLowerCase() === String(fieldName).toLowerCase();
      });
    }

    function stripCurrencyPrefix(value) {
      var raw = String(value === null || typeof value === "undefined" ? "" : value).trim();
      return raw.replace(/^(GBP|EUR|USD)\s+/i, "");
    }

    function formatMoneyValue(value, fieldName) {
      var raw = stripCurrencyPrefix(value);
      if (!raw) {
        return raw;
      }
      if (!isCurrencyField(fieldName)) {
        return raw;
      }
      var num = Number(String(raw).replace(/[^0-9.-]/g, ""));
      if (!isNaN(num) && /^[0-9.,+-]+$/.test(String(raw))) {
        return currencySymbol + num.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      return currencySymbol + raw;
    }

    function formatAxisMoney(value, fieldName) {
      if (!isCurrencyField(fieldName)) {
        return value;
      }
      var num = Number(value);
      if (isNaN(num)) {
        return value;
      }
      return currencySymbol + num.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    function parseNames(value) {
      if (!value) {
        return [];
      }

      if (Array.isArray(value)) {
        return value;
      }

      try {
        var parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
      }

      return [value];
    }

    function numberOrZero(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return 0;
      }

      var normalized = String(value).replace(/[^0-9.-]/g, "");
      var result = Number(normalized);
      return isNaN(result) ? 0 : result;
    }

    var rows = [];
    try {
      rows = JSON.parse(ADataJSON || "[]");
    } catch (e) {
      console.error("Unable to parse chart data JSON.", e);
      rows = [];
    }

    if (!Array.isArray(rows)) {
      rows = [];
    }

    canvas.__csyDashboardId = this.FDashboardId;
    canvas.__csyChartRows = rows;

    var yFields = parseNames(AYValueNames);
    var xFields = parseNames(AXLabelNames);
    var xField = xFields.length > 0 ? xFields[0] : "";
    var legends = Array.isArray(ALegendData) ? ALegendData : [];
    function formatLegendLabel(legendValue, fieldValue) {
      var value = String(legendValue || fieldValue || "").trim();
      if (!value) {
        return "";
      }
      // Unwrap JSON array legends such as ["CASHSELLNET"]
      if (value.charAt(0) === "[") {
        try {
          var parsedLegend = JSON.parse(value);
          if (Array.isArray(parsedLegend) && parsedLegend.length > 0) {
            value = String(parsedLegend[0] || "").trim();
          }
        } catch (e) {
        }
      }
      // Strip surrounding double quotes without quote chars inside regex literals
      var dq = String.fromCharCode(34);
      while (value.length >= 2 && value.charAt(0) === dq && value.charAt(value.length - 1) === dq) {
        value = value.substring(1, value.length - 1).trim();
      }
      var compact = value.replace(/[\s\[\]]+/g, "").toUpperCase();
      if (compact === "COSTNET") {
        return "Net Cost";
      }
      if (compact === "CASHSELLNET" || compact === "SELLNET") {
        return "Net Sales";
      }
      var lower = value.toLowerCase();
      if (lower.indexOf("like for like") >= 0) {
        var title = String(this.FTitle || "").toLowerCase();
        if (title.indexOf("takings") >= 0) {
          return "Takings";
        }
        if (title.indexOf("profit") >= 0) {
          return "Profit";
        }
        if (title.indexOf("sales") >= 0) {
          return "Sales";
        }
      }
      return value;
    }
    var chartKind = String(AChartType || "bar").toLowerCase();
    var axesOnly = rows.length === 0;

    if (chartKind === "bar") {
      chartKind = "bar";
    } else if (chartKind === "pie") {
      chartKind = "pie";
    } else if (chartKind === "line") {
      chartKind = "line";
    } else {
      chartKind = "bar";
    }

    if (axesOnly) {
      rows = [
        { placeholder: 0 },
        { placeholder: 0 },
        { placeholder: 0 },
        { placeholder: 0 },
        { placeholder: 0 }
      ];
      if (yFields.length === 0) {
        yFields = ["Value"];
      }
      if (!xField) {
        xField = "placeholder";
      }
    }

    if (yFields.length === 0 && rows.length > 0) {
      Object.keys(rows[0]).some(function(key) {
        if (key === xField) {
          return false;
        }
        if (numberOrZero(rows[0][key]) !== 0 || rows[0][key] === 0 || rows[0][key] === "0") {
          yFields.push(key);
          return true;
        }
        return false;
      });
    }

    var labels = [];
    var barColour = "#7DA7C4";
    var barBorder = "#4A6278";
    var linePalette = ["#9E9E9E", "#8BC34A", "#B0BEC5", "#A5D6A7"];
    var piePalette = ["#7DA7C4", "#9E9E9E", "#8BC34A", "#B0BEC5", "#90CAF9", "#BCAAA4"];
    var palette = chartKind === "line" ? linePalette : piePalette;

    if (chartKind !== "pie" && yFields.length === 0 && rows.length > 0 && !axesOnly) {
      yFields = Object.keys(rows[0]).filter(function(key) {
        if (key === xField) {
          return false;
        }
        var val = rows[0][key];
        return val !== null && typeof val !== "undefined" && String(val).trim() !== "";
      });
    }

    if (chartKind === "pie" && rows.length === 1) {
      var pieRow = rows[0];

      if (yFields.length <= 1) {
        var suffixFields = Object.keys(pieRow).filter(function(key) {
          if (key === xField) {
            return false;
          }
          return /_[01]$/.test(key);
        }).sort();

        if (suffixFields.length >= 2) {
          yFields = suffixFields.slice(0, 2);
        }
      }
    }

    if (chartKind === "pie" && yFields.length === 1 && rows.length === 1) {
      var yName = yFields[0];
      if (yName.indexOf("_XX") >= 0) {
        var baseName = yName.replace("_XX", "");
        var expandedFields = [baseName + "_0", baseName + "_1"];
        var hasBoth = expandedFields.every(function(fieldName) {
          return Object.prototype.hasOwnProperty.call(rows[0], fieldName);
        });
        if (hasBoth) {
          yFields = expandedFields;
        }
      }
    }

    var datasets;
    if (chartKind === "pie") {
      var pieValues = [];
      var pieLabels = [];

      if (rows.length === 1 && yFields.length > 0) {
        pieLabels = yFields.map(function(field, index) {
          return formatLegendLabel.call(this, legends[index], field.replace(/_0$|_1$/, "").replace(/_/g, " "));
        }, this);
        pieValues = yFields.map(function(field) {
          return numberOrZero(rows[0][field]);
        });
      } else if (rows.length >= 2 && yFields.length === 1) {
        var compareField = yFields[0];
        pieLabels = rows.map(function(row, index) {
          if (xField && Object.prototype.hasOwnProperty.call(row, xField)) {
            return String(row[xField]);
          }
          return legends[index] || ("Period " + (index + 1));
        });
        pieValues = rows.map(function(row) {
          return numberOrZero(row[compareField]);
        });
      } else {
        var pieField = yFields.length > 0 ? yFields[0] : "";
        pieLabels = rows.map(function(row, index) {
          if (axesOnly) {
            return "";
          }
          if (xField && Object.prototype.hasOwnProperty.call(row, xField)) {
            return String(row[xField]);
          }
          return legends[index] || String(index + 1);
        });
        pieValues = rows.map(function(row) {
          return numberOrZero(row[pieField]);
        });
      }

      labels = pieLabels;
      datasets = [{
        label: formatLegendLabel.call(this, legends[0], "Values"),
        data: pieValues,
        backgroundColor: pieValues.map(function(_value, index) {
          return palette[index % palette.length];
        }),
        borderColor: "#ffffff",
        borderWidth: 1
      }];
    } else {
      labels = rows.map(function(row, index) {
        if (axesOnly) {
          return "";
        }
        if (xField && Object.prototype.hasOwnProperty.call(row, xField)) {
          return String(row[xField]);
        }
        return String(index + 1);
      });

      datasets = yFields.map(function(field, index) {
        var colour = chartKind === "bar" ? barColour : palette[index % palette.length];
        var border = chartKind === "bar" ? barBorder : colour;
        return {
          label: formatLegendLabel.call(this, legends[index], field),
          data: rows.map(function(row) {
            return axesOnly ? 0 : numberOrZero(row[field]);
          }),
          borderColor: axesOnly ? "rgba(0,0,0,0)" : border,
          backgroundColor: axesOnly ? "rgba(0,0,0,0)" : (chartKind === "line" ? colour + "55" : colour),
          borderWidth: axesOnly ? 0 : (chartKind === "bar" ? 1 : 2),
          pointRadius: axesOnly ? 0 : (chartKind === "line" ? 3 : 0),
          pointBackgroundColor: chartKind === "line" ? colour : undefined,
          pointBorderColor: chartKind === "line" ? colour : undefined,
          tension: chartKind === "line" ? 0.25 : 0,
          fill: false,
          maxBarThickness: chartKind === "bar" ? 42 : undefined,
          // Keep near-zero values clickable/visible (e.g. quiet trading hours)
          minBarLength: chartKind === "bar" && !axesOnly ? 4 : undefined
        };
      });
    }

    var updatedExisting = false;
    if (canvas.__csyChart) {
      var existingKind = canvas.__csyChartKind || "";
      if (existingKind === chartKind) {
        canvas.__csyChart.data.labels = labels;
        canvas.__csyChart.data.datasets = datasets;
        canvas.__csyHoverEnabled = AEnableHoverSelection;
        canvas.__csyAxesOnly = axesOnly;
        if (canvas.__csyChart.options && canvas.__csyChart.options.scales &&
            canvas.__csyChart.options.scales.y) {
          canvas.__csyChart.options.scales.y.beginAtZero = true;
          canvas.__csyChart.options.scales.y.min = 0;
          canvas.__csyChart.options.scales.y.grace = '5%';
        }
        if (canvas.__csyChart.options && canvas.__csyChart.options.plugins &&
            canvas.__csyChart.options.plugins.legend) {
          canvas.__csyChart.options.plugins.legend.display =
            !axesOnly && datasets.length >= 1;
          canvas.__csyChart.options.plugins.legend.position = 'top';
          canvas.__csyChart.options.plugins.legend.align = 'center';
        }
        canvas.__csyChart.update();
        if (AEnableHoverSelection && typeof canvas.__csyApplyHighlight === 'function') {
          canvas.__csyApplyHighlight(canvas.__csyChart, canvas, canvas.__csySelectedIndex || 0);
        }
        if (AEnableHoverSelection) {
          canvas.style.cursor = "pointer";
          canvas.classList.add("csy-chart-interactive");
        }
        updatedExisting = true;
        canvas.setAttribute('data-csy-chart-ready', '1');
      } else {
        canvas.__csyChart.destroy();
        canvas.__csyChart = null;
        canvas.__csyHoverBound = false;
      }
    }

    if (!updatedExisting) {
    canvas.__csyChartKind = chartKind;
    canvas.__csyHoverEnabled = AEnableHoverSelection;
    canvas.__csyAxesOnly = axesOnly;
    canvas.__csySelectedIndex = this.FSummaryIndex || 0;
    canvas.__csyPalette = palette;
    canvas.__csyBarColour = barColour;
    canvas.__csyBarBorder = barBorder;
    canvas.style.position = "absolute";
    canvas.style.inset = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.maxWidth = "100%";
    canvas.style.maxHeight = "100%";
    if (AEnableHoverSelection) {
      canvas.style.cursor = "pointer";
      canvas.classList.add("csy-chart-interactive");
    } else {
      canvas.style.cursor = "";
      canvas.classList.remove("csy-chart-interactive");
    }

    canvas.__csyApplyHighlight = function(chart, chartCanvas, index) {
      if (!chart || index < 0) {
        return;
      }
      var kind = chartCanvas.__csyChartKind;
      var colours = chartCanvas.__csyPalette;
      var highlight = "#F26922";
      var dimmed = "55";

      chart.data.datasets.forEach(function(ds, di) {
        var baseColour = colours[di % colours.length];
        if (kind === "pie") {
          ds.backgroundColor = ds.data.map(function(_v, i) {
            return i === index ? highlight : baseColour + dimmed;
          });
          ds.borderColor = "#ffffff";
        } else if (kind === "line") {
          ds.pointBackgroundColor = ds.data.map(function(_v, i) {
            return i === index ? highlight : baseColour;
          });
          ds.pointBorderColor = ds.data.map(function(_v, i) {
            return i === index ? "#ffffff" : baseColour;
          });
          ds.pointRadius = ds.data.map(function(_v, i) {
            return i === index ? 7 : 3;
          });
          ds.pointHoverRadius = ds.data.map(function(_v, i) {
            return i === index ? 8 : 4;
          });
        } else {
          var barFill = chartCanvas.__csyBarColour || baseColour;
          var barEdge = chartCanvas.__csyBarBorder || baseColour;
          ds.backgroundColor = ds.data.map(function(_v, i) {
            return i === index ? highlight : barFill + dimmed;
          });
          ds.borderColor = ds.data.map(function(_v, i) {
            return i === index ? "#C55A11" : barEdge;
          });
          ds.borderWidth = ds.data.map(function(_v, i) {
            return i === index ? 2 : 1;
          });
        }
      });
      chart.update("none");
    };

    var hoverOptions = AEnableHoverSelection ? {
      mode: "index",
      intersect: false
    } : {
      mode: "nearest",
      intersect: true
    };

    canvas.__csyChart = new Chart(canvas.getContext("2d"), {
      type: chartKind,
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: hoverOptions,
        hover: hoverOptions,
        layout: {
          padding: { top: 4, right: 8, bottom: 8, left: 4 }
        },
        plugins: {
          legend: {
            // Show for any chart with real data (line/bar/pie), not pie-only
            display: !axesOnly && datasets.length >= 1,
            position: "top",
            align: "center",
            labels: {
              boxWidth: 12,
              boxHeight: 12,
              padding: 10,
              usePointStyle: false,
              generateLabels: function(chart) {
                var chartCanvas = chart.canvas;
                var kind = chartCanvas.__csyChartKind || chart.config.type || "";
                if (kind === "pie" || kind === "doughnut") {
                  var data = chart.data;
                  if (!data || !data.labels || !data.datasets || data.datasets.length === 0) {
                    return [];
                  }
                  var dataset = data.datasets[0];
                  var meta = chart.getDatasetMeta(0);
                  return data.labels.map(function(label, index) {
                    var style = meta.controller.getStyle(index, false);
                    var bg = Array.isArray(dataset.backgroundColor)
                      ? dataset.backgroundColor[index]
                      : dataset.backgroundColor;
                    var value = dataset.data[index];
                    var legendText = String(label || "");
                    if (value !== null && typeof value !== "undefined" && value !== "") {
                      var pieField = (yFields && yFields.length > 0) ? yFields[0] : "";
                      legendText = legendText + ": " + formatMoneyValue(value, pieField);
                    }
                    return {
                      text: legendText,
                      fillStyle: bg || style.backgroundColor,
                      strokeStyle: style.borderColor || "#ffffff",
                      lineWidth: style.borderWidth || 1,
                      hidden: !chart.getDataVisibility(index),
                      index: index,
                      datasetIndex: 0
                    };
                  });
                }

                var items = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                items.forEach(function(item, index) {
                  if (chartCanvas.__csyChartKind === "bar" && chartCanvas.__csyBarColour) {
                    item.fillStyle = chartCanvas.__csyBarColour;
                    item.strokeStyle = chartCanvas.__csyBarBorder || chartCanvas.__csyBarColour;
                    item.lineWidth = 1;
                  } else if (chartCanvas.__csyPalette && chartCanvas.__csyPalette.length > 0) {
                    var colour = chartCanvas.__csyPalette[index % chartCanvas.__csyPalette.length];
                    item.fillStyle = colour;
                    item.strokeStyle = colour;
                  }
                });
                return items;
              }
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function(context) {
                var fieldName = "";
                if (yFields && yFields.length > context.datasetIndex) {
                  fieldName = yFields[context.datasetIndex];
                } else if (context.dataset && context.dataset.label) {
                  fieldName = context.dataset.label;
                }
                var val = (context.parsed && typeof context.parsed.y !== "undefined")
                  ? context.parsed.y
                  : context.parsed;
                var formatted = formatMoneyValue(val, fieldName);
                var prefix = context.dataset && context.dataset.label ? context.dataset.label + ": " : "";
                return prefix + formatted;
              }
            }
          }
        },
        datasets: chartKind === "bar" ? {
          bar: {
            barPercentage: 0.72,
            categoryPercentage: 0.82
          }
        } : {},
        scales: chartKind === "pie" ? {} : {
          x: {
            display: true,
            grid: { display: true, color: "rgba(0,0,0,0.06)" },
            ticks: { display: !axesOnly, maxRotation: 0, autoSkip: true }
          },
          y: {
            display: true,
            beginAtZero: true,
            min: 0,
            grace: "5%",
            grid: { display: true, color: "rgba(0,0,0,0.06)" },
            ticks: {
              display: !axesOnly,
              callback: function(value) {
                var yField = "";
                if (yFields && yFields.length > 0) {
                  yField = yFields[0];
                  for (var yi = 0; yi < yFields.length; yi++) {
                    if (isCurrencyField(yFields[yi])) {
                      yField = yFields[yi];
                      break;
                    }
                  }
                }
                return formatAxisMoney(value, yField);
              }
            }
          }
        }
      }
    });

    if (AEnableHoverSelection && typeof canvas.__csyApplyHighlight === "function") {
      canvas.__csyApplyHighlight(canvas.__csyChart, canvas, canvas.__csySelectedIndex || 0);
    }
    canvas.setAttribute('data-csy-chart-ready', '1');
    } // !updatedExisting
  end;

  HideDataSkeleton;

  if AEnableHoverSelection then
    EnsureChartHoverHandlers;

  ApplyChartPanelHeight;
end;

procedure TBaseDashboardItem.SetDashboardId(ADashboardItemId: integer);
begin
  // Select the DashboardItem from the table
  FDashboardId := ADashboardItemId;
end;

procedure TBaseDashboardItem.SetTitle(ATitle: string);
begin
  FTitle := ATitle;
  CreateTitleLabel;

  if assigned(FTitleLabel) then
  begin
    FTitleLabel.Caption := FTitle;
    FTitleLabel.Visible := FTitle <> '';
  end;

  asm
    var root = document.getElementById(this.ElementID);
    if (root) {
      root.setAttribute('data-csy-title', ATitle || '');
    }
    var title = document.getElementById('csy_title_' + this.FDashboardId);
    if (!title) {
      return;
    }
    title.style.width = 'auto';
    title.style.maxWidth = '100%';
    title.style.flex = '1 1 auto';
    title.style.overflow = 'visible';
    title.style.whiteSpace = 'normal';
    title.style.display = (ATitle && ATitle.length > 0) ? 'block' : 'none';
    var inner = title.querySelector('div');
    if (inner) {
      inner.textContent = ATitle || '';
      inner.style.width = 'auto';
      inner.style.maxWidth = '100%';
      inner.style.overflow = 'visible';
      inner.style.whiteSpace = 'normal';
    } else {
      title.textContent = ATitle || '';
    }
  end;
end;

procedure TBaseDashboardItem.ComboBoxChange(Sender: TObject);
begin
  await(NewSummarySelected);
end;

procedure TBaseDashboardItem.NewSummarySelected;
var
  lDrillDownSQL: string;
  lNewSummaryParam: string;
  lPlaceholder: string;
begin
  if not Assigned(FComboBox) or (FComboBox.ItemIndex < 0) then
    Exit;

  FSummaryIndex := FComboBox.ItemIndex;
  lNewSummaryParam := FComboBox.Items[FComboBox.ItemIndex];
  if Trim(lNewSummaryParam) = '' then
    Exit;

  if RequiresDrillDownSQL then
  begin
    lPlaceholder := '@' + GetEffectiveDrillDownFieldName;
    if lPlaceholder = '@' then
      Exit;
    lDrillDownSQL := StringReplace(FDrillDownSQL, lPlaceholder, lNewSummaryParam,
      [rfReplaceAll, rfIgnoreCase]);
    await(RunSummarySQL(lDrillDownSQL));
    UpdateChartSelectionHighlight(FSummaryIndex);
  end
  else
    PopulateComboRowTable(FSummaryIndex);
end;

function TBaseDashboardItem.RequiresDrillDownSQL: Boolean;
begin
  Result := RequiresSqlDrillDownSummary or RequiresConfigDrillDownSummary;
end;

function TBaseDashboardItem.ShouldRunSummarySQLOnComboChange: Boolean;
begin
  Result := RequiresDrillDownSQL;
end;

function TBaseDashboardItem.UsesChartHoverSummary: Boolean;
begin
  if GetChartHeight <= 0 then
    Exit(False);
  if IsChartOnlyWidget then
    Exit(False);
  if IsDayLikeForLikeWidget then
    Exit(False);
  if IsTradingPatternWidget then
    Exit(True);
  if IsDrillDownComboEnabled then
    Exit(True);
  if RequiresConfigDrillDownSummary then
    Exit(True);
  if Assigned(FTemplate) and SameText(FTemplate.DashboardItemType, 'SQLLikeForLike') then
    Exit(HasChartData(GetEffectiveChartJson));

  Result := UsesComboRowSummary;
end;

function TBaseDashboardItem.ShowSummaryCombo: Boolean;
begin
  Result := False;
end;

function TBaseDashboardItem.GetSummaryIterationCount: Integer;
begin
  Result := 1;
end;

function TBaseDashboardItem.ResolveSummaryColumnName(AFieldIndex,
  AIterationIndex: Integer): string;
begin
  Result := FConfiguration.SummaryFields[AFieldIndex].ToField;
end;

function TBaseDashboardItem.GetCurrencySymbol: string;
begin
  if Assigned(SharedData) and Assigned(SharedData.Dashboard) then
    Result := SharedData.Dashboard.DefaultCurrencySymbol
  else
    Result := #163;
end;

function TBaseDashboardItem.IsCurrencyFieldType(const AFieldType: string): Boolean;
begin
  Result := SameText(AFieldType, 'CurrDec');
end;

function TBaseDashboardItem.LooksLikeCurrencyFieldName(const AFieldName: string): Boolean;
var
  lName: string;
begin
  Result := False;
  lName := LowerCase(Trim(AFieldName));
  if lName = '' then
    Exit;

  lName := StringReplace(lName, '_', '', [rfReplaceAll]);
  lName := StringReplace(lName, ' ', '', [rfReplaceAll]);

  if (Pos('percent', lName) > 0) or (Pos('pct', lName) > 0) then
    Exit(False);
  if (Pos('quantity', lName) > 0) or (Pos('qty', lName) > 0) then
    Exit(False);
  if Pos('visit', lName) > 0 then
    Exit(False);
  if Pos('basket', lName) > 0 then
    Exit(False);
  if (Pos('transaction', lName) > 0) and (Pos('amount', lName) = 0) then
    Exit(False);
  if Pos('discount', lName) > 0 then
    Exit(False);
  if (Pos('transhour', lName) > 0) or (Pos('transdate', lName) > 0) then
    Exit(False);
  if (lName = 'hour') or (lName = 'day') or (lName = 'month') then
    Exit(False);

  if Pos('profit', lName) > 0 then
    Exit(True);
  if Pos('sellnet', lName) > 0 then
    Exit(True);
  if Pos('cashsellnet', lName) > 0 then
    Exit(True);
  if Pos('costnet', lName) > 0 then
    Exit(True);
  if Pos('taking', lName) > 0 then
    Exit(True);
  if Pos('refund', lName) > 0 then
    Exit(True);
  if Pos('spend', lName) > 0 then
    Exit(True);
  if (Pos('sales', lName) > 0) and (Pos('quantity', lName) = 0) then
    Exit(True);
  if (lName = 'sales') or (lName = 'sell') then
    Exit(True);
end;

function TBaseDashboardItem.ShouldFormatAsCurrency(const AFieldType,
  AFieldName: string): Boolean;
begin
  Result := IsCurrencyFieldType(AFieldType) or LooksLikeCurrencyFieldName(AFieldName);
end;

function TBaseDashboardItem.IsCurrencyFieldName(const AFieldName: string): Boolean;
begin
  Result := ShouldFormatAsCurrency('', AFieldName);
end;

function TBaseDashboardItem.NormalizeCurrencyValue(const AValue: string): string;
var
  lValue: string;
begin
  lValue := Trim(AValue);
  if lValue = '' then
    Exit('');

  if (Length(lValue) > 4) and SameText(Copy(lValue, 1, 4), 'GBP ') then
    Exit(Trim(Copy(lValue, 5, MaxInt)));
  if (Length(lValue) > 4) and SameText(Copy(lValue, 1, 4), 'EUR ') then
    Exit(Trim(Copy(lValue, 5, MaxInt)));
  if (Length(lValue) > 4) and SameText(Copy(lValue, 1, 4), 'USD ') then
    Exit(Trim(Copy(lValue, 5, MaxInt)));

  Result := lValue;
end;

function TBaseDashboardItem.FormatCurrencyValue(const AValue: string): string;
var
  lNormalized: string;
begin
  lNormalized := NormalizeCurrencyValue(AValue);
  if lNormalized = '' then
    Exit('');
  Result := GetCurrencySymbol + lNormalized;
end;

function TBaseDashboardItem.BuildCurrencyFieldNamesJson: string;
var
  lIdx: Integer;
  lField: TSummaryArray;
  lNames: TStringList;
  lYNames: TJSArray;
  lYName: string;
  lEscaped: string;
begin
  lNames := TStringList.Create;
  try
    lNames.CaseSensitive := False;

    for lIdx := 0 to Length(FConfiguration.SummaryFields) - 1 do
    begin
      lField := FConfiguration.SummaryFields[lIdx];
      if Trim(lField.ToField) <> '' then
      begin
        if ShouldFormatAsCurrency(lField.FieldType, lField.ToField) and
           (lNames.IndexOf(Trim(lField.ToField)) < 0) then
          lNames.Add(Trim(lField.ToField));
      end;
      if Trim(lField.SearchName) <> '' then
      begin
        if ShouldFormatAsCurrency(lField.FieldType, lField.SearchName) and
           (lNames.IndexOf(Trim(lField.SearchName)) < 0) then
          lNames.Add(Trim(lField.SearchName));
      end;
    end;

    if Trim(FConfiguration.YValueName) <> '' then
    begin
      try
        lYNames := TJSArray(TJSJSON.parse(FConfiguration.YValueName));
        for lIdx := 0 to lYNames.Length - 1 do
        begin
          lYName := Trim(string(lYNames[lIdx]));
          if (lYName <> '') and LooksLikeCurrencyFieldName(lYName) and
             (lNames.IndexOf(lYName) < 0) then
            lNames.Add(lYName);
        end;
      except
      end;
    end;

    Result := '[]';
    if lNames.Count = 0 then
      Exit;

    Result := '[';
    for lIdx := 0 to lNames.Count - 1 do
    begin
      if lIdx > 0 then
        Result := Result + ',';
      lEscaped := StringReplace(lNames[lIdx], '\', '\\', [rfReplaceAll]);
      lEscaped := StringReplace(lEscaped, '"', '\"', [rfReplaceAll]);
      Result := Result + '"' + lEscaped + '"';
    end;
    Result := Result + ']';
  finally
    lNames.Free;
  end;
end;

function TBaseDashboardItem.FormatSummaryCellValue(const AFieldType, AFieldName,
  AValue: string): string;
begin
  if ShouldFormatAsCurrency(AFieldType, AFieldName) then
    Result := FormatCurrencyValue(AValue)
  else
    Result := AValue;
end;

procedure TBaseDashboardItem.RunSummary(AIndex: integer);
var
  lData: string;
  lMainDataArray: JS.TJSArray;
  lColumnData: JS.TJSObject;
  lChartData: string;
  lDrillDownField: string;
  lDrillDownSQL: string;
  lDrillDownName: string;
begin
  if Trim(FChartData) = '' then
    Exit;

  lChartData := FChartData;
  lMainDataArray := JS.toArray(TJSJSON.parse(lChartData));
  if (lMainDataArray.Length = 0) or (AIndex < 0) or (AIndex >= lMainDataArray.Length) then
    Exit;

  lColumnData := JS.toObject(lMainDataArray.Elements[AIndex]);

  if Trim(FDrillDownSQL) = '' then
  begin
    if Trim(FConfiguration.DrilDownSQL) <> '' then
      FDrillDownSQL := ResolveSqlParameters(Trim(FConfiguration.DrilDownSQL))
    else if Assigned(FTemplate) and (Trim(FTemplate.SQLSummary) <> '') then
      FDrillDownSQL := ResolveSqlParameters(Trim(FTemplate.SQLSummary))
    else
      Exit;
  end;

  lDrillDownField := FConfiguration.DrillDownFieldName;
  lDrillDownSQL := FDrillDownSQL;
  lDrillDownName := FormatDrillDownParameterValue(lDrillDownField,
    String(lColumnData[lDrillDownField]));
  if Trim(lDrillDownName) = '' then
    lDrillDownName := FormatDrillDownParameterValue(lDrillDownField,
      GetChartRowFieldValue(AIndex, lDrillDownField));
  if Trim(lDrillDownName) = '' then
    Exit;

  lDrillDownSQL := ReplaceDrillDownPlaceholder(FDrillDownSQL, lDrillDownField,
    lDrillDownName);

  if Trim(lDrillDownSQL) <> '' then
    await(RunSummarySQL(lDrillDownSQL));
end;

procedure TBaseDashboardItem.RunSummarySQL(ASQL: string);
var
  lSummaryData: string;
begin
  if Trim(ASQL) = '' then
    Exit;
  if SameText(Trim(ASQL), 'undefined') then
    Exit;

  try
    lSummaryData := Await(SharedData.Dashboard.GetDashboardSummaryData(ASQL, FConfiguration.SummaryFields));
    if (Trim(lSummaryData) = '') or (Trim(lSummaryData) = '[]') then
      Exit;
    PopulateSummaryTableFromJson(lSummaryData, GetSummaryRowCount);
  except
    on E: Exception do
    begin
      asm
        console.log('RunSummarySQL failed');
      end;
    end;
  end;
end;

procedure TBaseDashboardItem.CreateSummaryFieldsTableRowIndex(ASummaryData: string; ARowIndex: integer);
var
  I, J: integer;
  lColumnName: string;
  lFieldType: string;
  lSummaryData: string;
  lSummaryArray: JS.TJSArray;
  lRowData: JS.TJSObject;
begin
  if Trim(ASummaryData) = '' then
    Exit;

  lSummaryData := ASummaryData;
  lSummaryArray := JS.toArray(TJSJSON.parse(lSummaryData));
  if (lSummaryArray.Length = 0) or (ARowIndex < 0) or (ARowIndex >= lSummaryArray.Length) then
    Exit;

  try
    if not Assigned(FSummaryGrid) then
    begin
      FSummaryGrid := TTableControl.Create(Self);
      FSummaryGrid.Parent := GetSummaryTableParentPanel;
      FSummaryGrid.ColCount := Length(FConfiguration.SummaryFields);
      FSummaryGrid.Font.Height := 4;
      FSummaryGrid.Align := alTop;
      if UsesChartSummaryFixedHeight then
        FSummaryGrid.AlignWithMargins := False
      else
        FSummaryGrid.AlignWithMargins := True;
      FSummaryGrid.ElementPosition := epRelative;
      FSummaryGrid.ElementID := 'csy_summary_' + IntToStr(FDashboardId);
      FSummaryGrid.ElementClassName := 'csy-widget-summary';
      FSummaryGrid.Options.ImageAlign := taCenter;
      if UsesChartSummaryFixedHeight then
        FSummaryGrid.RowCount := ResolveChartSummaryGridRowCount(GetSummaryIterationCount)
      else
        FSummaryGrid.RowCount := GetSummaryRowCount + 1;
    end;

    if (ARowIndex < 0) or (ARowIndex >= lSummaryArray.Length) then
      Exit;

    lRowData := JS.toObject(lSummaryArray[ARowIndex]);

    if UsesChartSummaryFixedHeight then
    begin
      FSummaryGrid.RowCount := ResolveChartSummaryGridRowCount(GetSummaryIterationCount);
      for J := 0 to FSummaryGrid.RowCount - 2 do
        for I := 0 to Length(FConfiguration.SummaryFields) - 1 do
          FSummaryGrid.Cells[I, J + 1] := '';
    end
    else
    begin
      FSummaryGrid.RowCount := GetSummaryRowCount + 1;
      for J := 0 to GetSummaryRowCount - 1 do
        for I := 0 to Length(FConfiguration.SummaryFields) - 1 do
          FSummaryGrid.Cells[I, J + 1] := '';
    end;

    for J := 0 to GetSummaryIterationCount - 1 do
    begin
      if UsesChartSummaryFixedHeight then
      begin
        if (J + 1) >= FSummaryGrid.RowCount then
          Break;
      end
      else if (J + 1) > GetSummaryRowCount then
        Break;
      for I := 0 to Length(FConfiguration.SummaryFields) - 1 do
      begin
        lFieldType := FConfiguration.SummaryFields[I].FieldType;
        FSummaryGrid.Cells[I, J + 1] := FormatSummaryCellValue(lFieldType,
          ResolveSummaryColumnName(I, J),
          GetSummaryFieldValueAtIteration(lRowData, I, J));
      end;
    end;
    SyncSummaryGridContentHeight;
    ApplySummaryTableLayout;
    ApplyWidgetTableHeaderStyles;
    ConfigureSummaryTableInteraction;
  finally
  end;
end;

procedure TBaseDashboardItem.CreateSummaryTable(ARowCount: integer; AColumnCount: integer);
var
  I: integer;
begin
  if AColumnCount <= 0 then
    AColumnCount := Length(FConfiguration.SummaryFields);
  if ARowCount <= 0 then
  begin
    if UsesChartSummaryFixedHeight then
      ARowCount := GetChartSummaryVisibleRowCount
    else
      ARowCount := GetSummaryRowCount;
  end;

  try
    if not Assigned(FSummaryGrid) then
    begin
      FSummaryGrid := TTableControl.Create(Self);
      FSummaryGrid.Parent := GetSummaryTableParentPanel;
      FSummaryGrid.ColCount := AColumnCount;
      FSummaryGrid.RowCount := ARowCount + 1;
      FSummaryGrid.Font.Height := 4;
      FSummaryGrid.Align := alTop;
      if UsesChartSummaryFixedHeight then
        FSummaryGrid.AlignWithMargins := False
      else
        FSummaryGrid.AlignWithMargins := True;
      FSummaryGrid.ElementPosition := epRelative;
      FSummaryGrid.ElementID := 'csy_summary_' + IntToStr(FDashboardId);
      FSummaryGrid.ElementClassName := 'csy-widget-summary';
      FSummaryGrid.Options.ImageAlign := taCenter;
    end
    else
    begin
      FSummaryGrid.ColCount := AColumnCount;
      if UsesChartSummaryFixedHeight then
        FSummaryGrid.RowCount := ResolveChartSummaryGridRowCount(ARowCount)
      else
        FSummaryGrid.RowCount := ARowCount + 1;
    end;

    for I := 0 to AColumnCount - 1 do
    begin
      if (I < Length(FConfiguration.SummaryFields)) and Assigned(FConfiguration.SummaryFields[I]) then
        FSummaryGrid.Cells[I, 0] := FConfiguration.SummaryFields[I].DisplayName
      else
        FSummaryGrid.Cells[I, 0] := '';
    end;
    ApplySummaryTableLayout;
    ApplyWidgetTableHeaderStyles;
    ConfigureSummaryTableInteraction;
  finally
  end;
end;

(*
var
  I, J: integer;
  lColumnName: string;
  lValue: JS.TJSObject;
  lSummaryData: string;
  lSummaryArray: JS.TJSArray;
//  lCount: integer;
begin
  lSummaryData := ASummaryData;
  lSummaryArray := JS.toArray(TJSJSON.parse(lSummaryData));

  try
    if not Assigned(FSummaryGrid) then
    begin
      FSummaryGrid := TWebTableControl.Create(Self);
      FSummaryGrid.Parent := Self;
      FSummaryGrid.ColCount := Length(AFieldNames);
      FSummaryGrid.RowCount := lSummaryArray.Length + 1;
      FSummaryGrid.Height := (FSummaryGrid.RowCount+1) * 28;
      FSummaryGrid.Font.Height := 4;
      FSummaryGrid.Align := alTop;
      if UsesChartSummaryFixedHeight then
        FSummaryGrid.AlignWithMargins := False
      else
        FSummaryGrid.AlignWithMargins := True;
      FSummaryGrid.Options.ImageAlign := taCenter;
    end;

    for I := 0 to Length(AFieldNames)-1 do
    begin
      lColumnName := AFieldNames[I];
      FSummaryGrid.Cells[I,0] := StringReplace(lColumnName, '_', ' ', [rfReplaceAll]);

      for J := 0 to lSummaryArray.Length-1 do
      begin
        lValue := JS.toObject(lSummaryArray[J]);
        FSummaryGrid.Cells[I,J+1] := String(lValue[lColumnName]);
      end;
    end;
  finally
  end;
end;
*)
procedure TBaseDashboardItem.PopulateSummaryTableData(ASummaryData: string; AColumnCount: integer; ARowCount: integer);
begin
  PopulateSummaryTableFromJson(ASummaryData, ARowCount);
end;

procedure TBaseDashboardItem.PopulateSummaryTableFromJson(const ADataJSON: string; AMaxRows: Integer);
var
  lRowIndex: Integer;
  lValue: JS.TJSObject;
  lSummaryArray: JS.TJSArray;
  lColumnIndex: Integer;
  lFieldType: string;
  lDataRowCount: Integer;
begin
  if Trim(ADataJSON) = '' then
    Exit;

  if Length(FConfiguration.SummaryFields) = 0 then
    Exit;

  lSummaryArray := JS.toArray(TJSJSON.parse(ADataJSON));
  if lSummaryArray.Length = 0 then
    Exit;

  lDataRowCount := lSummaryArray.Length;
  // Always honour AMaxRows. Chart widgets use a fixed footer viewport, but
  // trading-pattern summaries are still single-selection (1 row), not a
  // scrollable dump of every chart point.
  if (AMaxRows > 0) and (AMaxRows < lDataRowCount) then
    lDataRowCount := AMaxRows;

  EnsureSummaryGridDataRows(lDataRowCount, Length(FConfiguration.SummaryFields));

  for lColumnIndex := 0 to Length(FConfiguration.SummaryFields) - 1 do
    FSummaryGrid.Cells[lColumnIndex, 0] := FConfiguration.SummaryFields[lColumnIndex].DisplayName;

  for lRowIndex := 0 to lDataRowCount - 1 do
  begin
    lValue := JS.toObject(lSummaryArray[lRowIndex]);
    for lColumnIndex := 0 to Length(FConfiguration.SummaryFields) - 1 do
    begin
      lFieldType := FConfiguration.SummaryFields[lColumnIndex].FieldType;
      FSummaryGrid.Cells[lColumnIndex, lRowIndex + 1] := FormatSummaryCellValue(lFieldType,
        FConfiguration.SummaryFields[lColumnIndex].ToField,
        GetSummaryFieldValue(lValue, lColumnIndex));
    end;
  end;

  SyncSummaryGridContentHeight;
  ApplySummaryTableLayout;
  ApplyWidgetTableHeaderStyles;
  ConfigureSummaryTableInteraction;
  EnsureSummaryGridVisible;
  EnsureCardChromeClasses;
  LockChartSummaryFooterLayout;
end;

procedure TBaseDashboardItem.PopulateSummaryTableRowData(ARowIndex: integer; ARowData: JS.TJSObject);
var
  lColumnIndex: integer;
  lColumnName: string;
  lFieldType: string;
begin
  for lColumnIndex := 0 to Length(FConfiguration.SummaryFields) - 1 do
  begin
    lColumnName := FConfiguration.SummaryFields[lColumnIndex].ToField;
    lFieldType := FConfiguration.SummaryFields[lColumnIndex].FieldType;
    FSummaryGrid.Cells[lColumnIndex, ARowIndex + 1] := FormatSummaryCellValue(lFieldType,
      lColumnName, String(ARowData[lColumnName]));
  end;
end;


function TBaseDashboardItem.GetSummaryFieldCount: integer;
begin
  result := Length(FConfiguration.SummaryFields);
end;

procedure TBaseDashboardItem.ChartTimerTimer(Sender: TObject);
begin
//  ChartTimer.Enabled := False;
//  Visible := true;

//  if assigned(FNCChart) then
//    FNCChart.Visible := True;
end;

procedure TBaseDashboardItem.TestClick(Sender: TObject);
begin
  Refresh;
end;

procedure TBaseDashboardItem.ResolveLegend;

  function NormalizeLegendToken(const AValue: string): string;
  var
    lNorm: string;
    lValue: string;
    lArr: TJSArray;
  begin
    Result := Trim(AValue);
    if Result = '' then
      Exit;

    // YValueName is often stored as a JSON array string, e.g. ["CASHSELLNET"]
    if (Length(Result) >= 2) and (Result[1] = '[') then
    begin
      try
        lArr := TJSArray(TJSJSON.parse(Result));
        if Assigned(lArr) and (lArr.Length > 0) then
          Result := Trim(string(lArr[0]));
      except
        // keep Result as-is
      end;
    end;

    lValue := Trim(Result);
    while (Length(lValue) >= 2) and
      (((lValue[1] = '"') and (lValue[Length(lValue)] = '"')) or
       ((lValue[1] = '''') and (lValue[Length(lValue)] = ''''))) do
      lValue := Trim(Copy(lValue, 2, Length(lValue) - 2));
    Result := lValue;

    lNorm := UpperCase(StringReplace(Result, ' ', '', [rfReplaceAll]));
    lNorm := StringReplace(lNorm, '[', '', [rfReplaceAll]);
    lNorm := StringReplace(lNorm, ']', '', [rfReplaceAll]);
    lNorm := StringReplace(lNorm, '"', '', [rfReplaceAll]);

    if (lNorm = 'COSTNET') or SameText(Result, 'CostNet') then
      Exit('Net Cost');
    if (lNorm = 'CASHSELLNET') or SameText(Result, 'CASHSELLNET') then
      Exit('Net Sales');
    if (lNorm = 'SELLNET') or SameText(Result, 'Sell_Net') or SameText(Result, 'SellNet') then
      Exit('Net Sales');

    if SameText(Result, 'Day: Like For Like') or SameText(Result, 'Day Like For Like') then
    begin
      if Pos('Takings', FTitle) > 0 then
        Exit('Takings')
      else if Pos('Profit', FTitle) > 0 then
        Exit('Profit')
      else if Pos('Sales', FTitle) > 0 then
        Exit('Sales');
    end;

    Result := lValue;
  end;

  function IsGenericLflLegend(const AValue: string): Boolean;
  var
    lNorm: string;
  begin
    lNorm := LowerCase(Trim(AValue));
    Result := (Pos('like for like', lNorm) > 0) and
      (Pos('takings', lNorm) = 0) and (Pos('profit', lNorm) = 0) and (Pos('sales', lNorm) = 0);
  end;

  procedure EnsureTitleLegendDefaults;
  begin
    if Pos('Day Like For Like Takings', FTitle) > 0 then
    begin
      if (Length(FConfiguration.LegendData) = 0) or
         ((Length(FConfiguration.LegendData) = 1) and IsGenericLflLegend(FConfiguration.LegendData[0])) then
      begin
        SetLength(FConfiguration.LegendData, 1);
        FConfiguration.LegendData[0] := 'Takings %Year';
      end;
      Exit;
    end;

    if Pos('Day Like For Like Profit', FTitle) > 0 then
    begin
      if (Length(FConfiguration.LegendData) = 0) or
         ((Length(FConfiguration.LegendData) = 1) and IsGenericLflLegend(FConfiguration.LegendData[0])) then
      begin
        SetLength(FConfiguration.LegendData, 1);
        FConfiguration.LegendData[0] := 'Profit %Year';
      end;
      Exit;
    end;

    if (Length(FConfiguration.LegendData) = 0) and (Trim(FConfiguration.YValueName) <> '') then
    begin
      SetLength(FConfiguration.LegendData, 1);
      FConfiguration.LegendData[0] := NormalizeLegendToken(FConfiguration.YValueName);
    end;
  end;

var
  lIdx: integer;
  lLegendText: string;
begin
  EnsureTitleLegendDefaults;

  for lIdx := 0 to Length(FConfiguration.LegendData)-1 do
  begin
    lLegendText := NormalizeLegendToken(FConfiguration.LegendData[lIdx]);

    if Pos('%Year', lLegendText) > 0 then
      lLegendText := StringReplace(lLegendText, '%Year', inttostr(FYear), [rfIgnoreCase, rfReplaceAll]);
    if Pos('%PrevYear', lLegendText) > 0 then
      lLegendText := StringReplace(lLegendText, '%PrevYear', inttostr(FYear-1), [rfIgnoreCase, rfReplaceAll]);

    FConfiguration.LegendData[lIdx] := lLegendText;
  end;
end;


end.


